import type { Key } from "./en";

export const pl: Record<Key, string> = {
  "person.mute": "Wycisz dla mnie",
  "person.volume": "Głośność dla mnie",
  "person.muted": "Wyciszono dla mnie",
  "person.changed": "Głośność dla mnie: {volume}%",
  "person.controls": "Opcje: {name}",
  "person.voiceSettings": "Ustawienia dźwięku",
  "audio.listen": "Posłuchaj siebie",
  "audio.stopListening": "Zatrzymaj test",
  "audio.listenHint": "3 s nagrania. Użyj słuchawek.",
  "audio.recording": "Mów teraz…",
  "audio.preparing": "Przygotowywanie…",
  "audio.previewRetry": "Ponów podgląd mikrofonu",
  "audio.playing": "Odsłuch…",
  "audio.listenInCall": "Opuść rozmowę, aby zrobić test.",
  "audio.listenMuted": "Włącz mikrofon, aby zrobić test.",

  "notify.scopeTitle": "Ustawienia powiadomień",
  "notify.scopeHint": "Wybierz, które wiadomości mają zwracać twoją uwagę. Wiadomości zostają na czacie.",
  "notify.mode.all": "Wszystkie wiadomości",
  "notify.mode.mentions": "Tylko wzmianki",
  "notify.mode.none": "Brak powiadomień",
  "notify.mode.default": "Użyj ustawień ogólnych",
  "notify.mode.server": "Użyj ustawień serwera",
  "notify.channelSettings": "Powiadomienia z kanału {name}",
  "desktop.loginApproval": "Zezwól Gwarowi na start",
  "desktop.loginSaved": "Zapisane uruchamianie przy logowaniu",
  "desktop.loginRemoveHint": "Wyłącz, aby usunąć zapisane ustawienie. Ta wersja macOS nie potwierdza, czy Gwar się uruchomi.",
  "desktop.loginRemovedHint": "Usunięto zapisane uruchamianie. Ponowne włączenie tutaj wymaga macOS 13 lub nowszego.",
  "desktop.loginSettings": "Ustawienia systemowe",
  "desktop.loginPending": "Start niepotwierdzony",
  "desktop.loginCheck": "Sprawdź",
  "desktop.openAtLogin": "Uruchamiaj przy logowaniu",
  "desktop.openAtLoginHint": "Otwieraj Gwar po zalogowaniu się do komputera.",
  "desktop.startMinimized": "Uruchamiaj zminimalizowany",
  "desktop.startMinimizedHint": "Po uruchomieniu Gwar okno pozostaje zminimalizowane.",
  "desktop.startupFailed": "Nie udało się odczytać lub zapisać ustawień uruchamiania.",
  "connect.invitation": "Zaproszenie",
  "connect.inviteDetails": "Szczegóły zaproszenia",
  "connect.inviteReviewHint": "Sprawdź adres serwera przed dołączeniem. Jego nazwę i uczestników zobaczysz po połączeniu.",
  "connect.joinServer": "Dołącz: {server}",
  "connect.openInApp": "Otwórz w aplikacji na komputer",
  "connect.reviewFailed": "Nie udało się rozłączyć z obecnym serwerem. Spróbuj ponownie.",
  "connect.reviewInvite": "Przejrzyj zaproszenie",
  "connect.leaveToReview": "Kontynuując, rozłączysz się z obecnym serwerem. Potem możesz sprawdzić zaproszenie i zdecydować, czy dołączyć.",
  "connect.inviteName": "Nazwa podana przez zapraszającego",
  "connect.inviteKey": "Odcisk klucza serwera",
  "desktop.retry": "Spróbuj ponownie",

  "settings.sounds": "Dźwięki aplikacji",
  "sounds.enabled": "Dźwięki zdarzeń",
  "sounds.hint": "Subtelne sygnały, gdy coś dzieje się w Gwarze.",
  "sounds.volume": "Głośność dźwięków",
  "sounds.deafenHint": "Po wyciszeniu słuchawek usłyszysz tylko zmiany wyciszenia mikrofonu i słuchawek. Głośność rozmowy ustawiasz osobno.",
  "sounds.preview": "Odtwórz: {event}",
  "sounds.voice": "Kanał głosowy",
  "sounds.controls": "Mikrofon i słuchawki",
  "sounds.connection": "Połączenie",
  "sounds.messages": "Wiadomości",
  "sounds.screen": "Udostępnianie ekranu",
  "sounds.selfJoin": "Dołączasz do rozmowy",
  "sounds.selfLeave": "Opuszczasz rozmowę lub się rozłączasz",
  "sounds.peerJoin": "Ktoś dołącza do Twojego kanału",
  "sounds.peerLeave": "Ktoś opuszcza Twój kanał",
  "sounds.mute": "Wyciszasz mikrofon",
  "sounds.unmute": "Włączasz mikrofon",
  "sounds.deafen": "Wyciszasz słuchawki",
  "sounds.undeafen": "Włączasz słuchawki",
  "sounds.connectionLost": "Utrata połączenia głosowego",
  "sounds.reconnected": "Przywrócenie połączenia głosowego",
  "sounds.mention": "Ktoś Cię wspomina",
  "sounds.directMessage": "Otrzymujesz wiadomość prywatną",
  "sounds.shareStarted": "Ktoś zaczyna udostępniać ekran",
  "sounds.shareStopped": "Twoje udostępnianie nagle się kończy",

  "common.close": "Zamknij",
  "common.cancel": "Anuluj",
  "common.save": "Zapisz",
  "common.saved": "Zapisano",
  "common.create": "Utwórz",
  "common.delete": "Usuń",
  "common.copy": "Kopiuj",

  "storage.newer.title": "Gwar nie może otworzyć zapisanych danych",
  "storage.newer.body": "Nowsza wersja Gwar zapisała dane w tej przeglądarce lub aplikacji, a ta wersja nie potrafi ich odczytać. Niczego nie zmieniono. Odśwież stronę albo zainstaluj najnowszy Gwar.",

  "nav.servers": "Serwery",
  "nav.sections": "Sekcje",
  "nav.home": "Start",
  "nav.account": "Twój profil",
  "nav.back": "Wstecz",
  "nav.more": "Więcej",
  "nav.profile": "Profil",
  "nav.toChannels": "Wróć do kanałów",

  "rail.label": "Zapisane serwery",
  "rail.connect": "Połącz",
  "rail.edit": "Edytuj",
  "rail.remove": "Usuń",
  "rail.add": "Dodaj serwer",
  "group.move": "Przenieś do grupy",
  "group.new": "Nowa grupa…",
  "group.newTitle": "Nowa grupa",
  "group.leave": "Wyjmij z grupy",
  "group.edit": "Edytuj grupę",
  "group.delete": "Usuń grupę",
  "group.collapse": "Zwiń grupę",
  "group.expand": "Rozwiń grupę",
  "group.description": "Grupy porządkują kolumnę serwerów. Są zapisane na tym urządzeniu.",
  "group.name": "Nazwa",
  "group.color": "Kolor",
  "group.colorN": "Kolor {n}",

  "home.greeting": "Cześć, {name}",
  "home.greetingAnon": "Cześć",
  "home.connected": "Połączono",
  "home.notConnected": "Brak połączenia",
  "home.pickServer": "Wybierz serwer, żeby dołączyć",
  "home.notInVoice": "Poza kanałem głosowym",
  "home.openServer": "Otwórz serwer",
  "home.connect": "Połącz z serwerem",
  "home.saved": "Zapisane serwery",
  "home.current": "Połączono teraz",

  "overview.title": "Przegląd",
  "overview.onlineCount": "online: {count}",
  "overview.voiceCount": "na głosowym: {count}",
  "overview.joinNamed": "Dołącz do {name}",
  "overview.join": "Dołącz",
  "overview.youAreHere": "Jesteś tutaj",
  "overview.voiceRooms": "Aktywne pokoje głosowe",
  "overview.nobodyTalks": "Nikt teraz nie rozmawia.",
  "overview.online": "Online teraz",
  "overview.inRoom": "Na głosowym: {name}",
  "overview.notInVoice": "Online",
  "overview.more": "i {count} więcej",
  "overview.noNews": "Na razie brak wiadomości.",
  "overview.attachment": "Załącznik",
  "overview.unread": "Nieprzeczytane",
  "overview.allRead": "Wszystko przeczytane.",

  "connect.title": "Witaj",
  "connect.subtitle": "Dołącz do serwera, aby rozmawiać i pisać ze swoimi ludźmi.",
  "connect.address": "Adres serwera",
  "connect.addressHint": "Nazwa hosta lub IP, np. voice.example.com albo 192.168.1.10:8790",
  "nickname.identityTitle": "Pseudonim tożsamości",
  "nickname.globalHint": "Używany na serwerach, na które wejdziesz po raz pierwszy. Na serwerze, na którym już jesteś, zmienisz pseudonim w menu tego serwera.",
  "nickname.change": "Zmień pseudonim",
  "nickname.serverHint": "Ten pseudonim należy do członka na tym serwerze i jest wspólny dla wszystkich jego urządzeń.",
  "nickname.invalid": "Wpisz pseudonim zawierający od 1 do 32 znaków.",
  "member.profile": "Profil członka",
  "member.viewProfile": "Zobacz profil",
  "member.uid": "Pełny identyfikator użytkownika",
  "member.handleChanged": "@{handle} należał wcześniej do innego konta. Handle może przejść na inne konto, więc to może być ktoś inny. Jeśli wiesz, że to ta sama osoba (np. na nowym koncie), zaakceptuj.",
  "member.acceptHandle": "Akceptuj to konto",
  "member.acceptNotSaved": "Nie zaakceptowano: przeglądarka nie pozwoliła tego zapisać. Odśwież stronę i spróbuj ponownie.",
  "badge.connectAccount": "Konto Gwar Connect: @{handle}",
  "badge.handleChanged": "@{handle}: ten handle należał wcześniej do innego konta",

  "connect.nickname": "Pseudonim",
  "connect.nicknamePlaceholder": "Jak mają się do Ciebie zwracać?",
  "connect.password": "Hasło serwera",
  "connect.passwordHint": "Serwer {server} jest chroniony hasłem.",
  "connect.remember": "Zapamiętaj ten serwer",
  "connect.submit": "Połącz",
  "connect.retrying": "Brak połączenia. Próbujemy ponownie…",
  "connect.otherTab": "Gwar jest otwarty w innej karcie",
  "connect.here": "Użyj tutaj",
  "connect.backToForm": "Wróć do formularza",
  "connect.connecting": "Łączenie…",
  "connect.saved": "Zapisane serwery",
  "connect.kind": "Typ serwera",
  "connect.kindVc": "Serwer Gwar",
  "connect.kindTs": "Serwer TeamSpeak",
  "connect.tsWebOnly": "Przeglądarki nie obsługują protokołu UDP TeamSpeak. Aby dołączyć do serwerów TeamSpeak, użyj aplikacji desktopowej.",
  "connect.tsAddressHint": "Nazwa hosta lub IP, np. ts.example.com. Domyślny port to 9987.",
  "connect.tsIdentity": "Tożsamość TeamSpeak",
  "connect.tsPassword": "Hasło serwera (opcjonalne)",
  "badge.teamspeak": "TeamSpeak",
  "badge.teamspeakShort": "TS",
  "addServer.tsPasswordHint": "Opcjonalne. Potrzebne tylko, gdy serwer TeamSpeak jest chroniony hasłem.",
  "addServer.tsChannel": "Kanał",
  "addServer.tsChannelHint": "Opcjonalne. Kanał, na który trafisz po połączeniu, razem z nadrzędnymi: Lobby/Gry.",
  "addServer.tsChannelPlaceholder": "Lobby/Gry",
  "addServer.tsChannelPassword": "Hasło kanału",
  "addServer.tsChannelPasswordHint": "Opcjonalne. Zapisywane tak jak hasło serwera.",
  "err.ts.desktopOnly": "Serwery TeamSpeak działają tylko w aplikacji desktopowej.",

  "close.kicked": "Zostałeś wyrzucony z serwera przez {by}.",
  "close.kickedReason": "Zostałeś wyrzucony z serwera przez {by}: {reason}",
  "close.replaced": "Zalogowano się z innego okna lub urządzenia, więc ta sesja została zamknięta.",
  "close.lost": "Utracono połączenie z serwerem.",

  "addServer.title": "Dodaj serwer",
  "addServer.editTitle": "Edytuj serwer",
  "addServer.description": "Zapisane serwery pojawiają się na pasku bocznym. Wszystko jest przechowywane tylko w tej przeglądarce.",
  "addServer.name": "Nazwa wyświetlana",
  "addServer.nameHint": "Opcjonalnie. Domyślnie nazwa nadana przez serwer.",
  "addServer.password": "Hasło serwera",
  "addServer.passwordHint": "Opcjonalnie. Zapisane w tej przeglądarce, by łączyć się jednym kliknięciem.",
  "addServer.saveConnect": "Zapisz i połącz",

  "settings.title": "Ustawienia",
  "alpha.badge": "Alpha",
  "alpha.hint": "Gwar jest w wersji alpha: mogą zdarzać się błędy i zmiany. Zgłaszaj, co nie działa.",
  "report.open": "Zgłoś błąd",
  "update.downloading": "Pobieranie Gwar {version}…",
  "update.downloadingProgress": "Pobieranie Gwar {version}: {percent}%",
  "update.ready": "Gwar {version} jest gotowy: kliknij, aby uruchomić ponownie i zaktualizować",
  "update.installing": "Instalowanie Gwar {version}…",
  "update.failed": "Nie udało się zaktualizować do Gwar {version}: {error}. Kliknij, aby spróbować ponownie.",
  "update.confirmTitle": "Uruchomić Gwar ponownie?",
  "update.confirmBody": "Instalacja Gwar {version} uruchamia aplikację ponownie i kończy udostępnianie ekranu. Rozmowa zostanie na chwilę przerwana, a Gwar spróbuje do niej wrócić.",
  "update.confirm": "Uruchom ponownie i zaktualizuj",
  "version.copy": "Gwar {version}: kliknij, aby skopiować",
  "version.copied": "Skopiowano {version}",
  "report.title": "Zgłoś błąd",
  "report.description": "Napisz, co poszło nie tak. Gwar jest w wersji alpha i każde zgłoszenie pomaga.",
  "report.what": "Co się stało?",
  "report.placeholder": "Co zrobiłeś, czego się spodziewałeś i co się stało zamiast tego?",
  "report.addShot": "Dodaj zrzut ekranu",
  "report.removeShot": "Usuń zrzut ekranu",
  "report.shotHint": "Wklej (Ctrl+V / ⌘V), upuść albo wybierz do 5 obrazów. Wytnij to, co prywatne: na zrzutach mogą być Twoje rozmowy.",
  "report.tooManyShots": "Najwyżej {max} zrzutów ekranu.",
  "report.badShot": "Tego obrazu nie można dołączyć (PNG, JPEG, WebP albo GIF).",
  "report.diagnostics": "Dołącz diagnostykę",
  "report.diagnosticsHint": "Wersja aplikacji, platforma, stan połączenia i głosu oraz ostatnie ostrzeżenia i błędy. Bez kluczy, haseł i wiadomości.",
  "report.showDiagnostics": "Pokaż, co zostanie wysłane",
  "report.hideDiagnostics": "Ukryj",
  "report.privacy": "Wysyłane prywatnie do zespołu Gwar (Gwar Connect), nie publikujemy tego.",
  "report.privacyAccount": "Wysyłane prywatnie do zespołu Gwar (Gwar Connect) z Twoim kontem @{handle}, nie publikujemy tego.",
  "report.send": "Wyślij zgłoszenie",
  "report.sent": "Dziękujemy! Zgłoszenie #{id} zostało wysłane.",
  "report.failed": "Zgłoszenie błędu nie zostało wysłane: {error}",
  "settings.audio": "Głos",
  "settings.appearance": "Wygląd",
  "settings.identity": "Tożsamość",
  "settings.language": "Język",
  "settings.identityUnavailable": "Nie udało się wczytać tożsamości w tej przeglądarce.",

  "audio.devices": "Urządzenia",
  "audio.input": "Mikrofon",
  "audio.output": "Głośniki",
  "audio.outputUnsupported": "Ta przeglądarka może używać tylko domyślnego wyjścia systemu.",
  "audio.systemDefault": "Domyślne systemowe",
  "audio.masterVolume": "Głośność wyjścia",
  "audio.inputMode": "Tryb wejścia",
  "audio.vad": "Aktywacja głosem",
  "audio.ptt": "Naciśnij i mów",
  "audio.vadHelp": "Mikrofon nadaje automatycznie, gdy mówisz.",
  "audio.automaticSensitivity": "Automatycznie ustalaj czułość",
  "audio.automaticSensitivityHint": "Wyłącz, aby ustawić ręcznie.",
  "audio.sensitivity": "Czułość mikrofonu",
  "audio.previewEnable": "Włącz podgląd mikrofonu",
  "audio.pressKey": "Naciśnij klawisz…",
  "audio.pressPtt": "Naciśnij klawisz lub mysz…",
  "audio.pttDelay": "Opóźnienie po puszczeniu",
  "audio.pttDelayLabel": "Opóźnienie po puszczeniu klawisza",
  "audio.pttAllow": "Zezwól",
  "audio.pttDetails": "Działanie klawisza do mówienia",
  "audio.pttStatus.ready": "Działa także poza Gwar.",
  "audio.pttStatus.permission": "Brak zgody. Mikrofon zamknięty.",
  "audio.pttStatus.recovering": "Klawisz nie działa. Mikrofon zamknięty.",
  "audio.pttStatus.unsupported": "Wybierz inny klawisz. Mikrofon zamknięty.",
  "audio.pttStatus.local": "Działa tylko w aktywnym oknie Gwar.",
  "audio.pttStatus.legacy": "Ten klawisz jest zajęty przez Gwar.",
  "audio.pttDetail.ready": "Gwar obserwuje tylko wybrany klawisz lub przycisk myszy. Nadal otrzymuje go aplikacja, której używasz. Lewy i prawy klawisz modyfikujący mają osobne przypisania.",
  "audio.pttDetail.permission": "Aby klawisz działał poza Gwar, zezwól aplikacji Gwar w Ustawieniach systemowych → Prywatność i ochrona → Monitorowanie wejścia. Przycisk „Zezwól” otwiera tę stronę. Do czasu uzyskania zgody mikrofon pozostaje zamknięty. Gwar sam sprawdza zgodę i nie pyta ponownie. Jeśli macOS o to poprosi, uruchom Gwar ponownie.",
  "audio.pttDetail.recovering": "Gwar nie może teraz bezpiecznie sprawdzić klawisza, więc mikrofon jest zamknięty. Próbuje ponownie automatycznie. Po wybudzeniu lub odblokowaniu puść klawisz i naciśnij go ponownie.",
  "audio.pttDetail.unsupported": "Ten system nie pozwala pewnie sprawdzić przytrzymania tego klawisza. Wybierz inny klawisz lub boczny przycisk myszy. Na macOS Caps Lock przełącza tryb i nie zgłasza pewnie przytrzymania.",
  "audio.pttDetail.local": "Przeglądarka lub system nie pozwala obserwować tego przycisku poza Gwar. Podczas mówienia pozostaw aktywne okno Gwar. Na Linuksie zależy to od systemu; część systemów pozwala używać klawiszy tylko w aktywnym oknie.",
  "audio.pttDetail.legacy": "Ten system Linux używa dotychczasowego skrótu globalnego. Inne aplikacje mogą nie otrzymać tego klawisza. Przyciski myszy i nieobsługiwane klawisze działają tylko w aktywnym oknie Gwar.",
  "audio.pttPrivacy": "Żadne inne naciśnięcia nie są zapisywane, logowane ani przekazywane. Używany jest tylko stan naciśnięcia wybranego przycisku.",
  "audio.pttRecovery": "Jeśli obserwowanie klawisza globalnego przestanie działać, mikrofon zamyka się bez opóźnienia. Po przywróceniu działania puść przycisk i naciśnij go ponownie.",
  "audio.pttSettingsFailed": "Otwórz Ustawienia systemowe → Prywatność i ochrona → Monitorowanie wejścia i włącz Gwar.",
  "audio.key.ControlLeft": "Lewy Ctrl",
  "audio.key.ControlRight": "Prawy Ctrl",
  "audio.key.ShiftLeft": "Lewy Shift",
  "audio.key.ShiftRight": "Prawy Shift",
  "audio.key.AltLeft": "Lewy Alt",
  "audio.key.AltRight": "Prawy Alt",
  "audio.key.MetaLeft": "Lewy Cmd/Win",
  "audio.key.MetaRight": "Prawy Cmd/Win",
  "audio.key.Mouse3": "Mysz 3",
  "audio.key.Mouse4": "Mysz 4",
  "audio.key.Mouse5": "Mysz 5",
  "audio.mouseButton": "Wybierz przycisk myszy",
  "voice.choosePttKey": "Wybierz klawisz do mówienia w ustawieniach dźwięku",
  "voice.openAudioSettings": "Otwórz ustawienia dźwięku.",
  "audio.setKey": "Wybierz klawisz",
  "audio.clearKey": "Wyczyść",
  "audio.pttHelp": "Klawisz działa w aktywnym oknie.",
  "audio.pttNoKey": "Wybierz klawisz do mówienia.",
  "audio.pttHelpGlobal": "Klawisz działa także poza Gwar.",
  "audio.globalShortcuts": "Skróty globalne",
  "audio.muteShortcut": "Wycisz mikrofon",
  "audio.deafenShortcut": "Wyłącz dźwięk",
  "audio.shortcutHint": "Działają także, gdy Gwar jest w tle.",
  "audio.shortcutNone": "Nie ustawiono",
  "audio.shortcutSet": "Ustaw skrót",
  "audio.shortcutFailed": "Nie udało się zarejestrować {key} jako skrótu globalnego. Może używa go inna aplikacja.",
  "desktop.window": "Okno",
  "desktop.closeToTray": "Działaj w zasobniku po zamknięciu okna",
  "desktop.closeToTrayHint": "Zamknięcie okna chowa Gwar do zasobnika systemowego. Zakończ aplikację z menu zasobnika.",
  "audio.level": "Poziom mikrofonu",
  "audio.processing": "Przetwarzanie",
  "audio.noiseSuppression": "Redukcja szumów",
  "audio.noiseSuppressionHint": "Wycisza szum tła i stukanie.",
  "audio.noiseStrength": "Siła redukcji szumów",
  "audio.noiseStrengthHint": "Przy 100% usuwa cały szum, jaki rozpozna, także stukanie klawiatury. Mniej zostawia trochę tła.",
  "audio.echoCancellation": "Usuwanie echa",
  "audio.echoCancellationHint": "Usuwa echo z głośników.",
  "audio.autoGain": "Wyrównywanie głośności",
  "audio.autoGainHint": "Dostosowuje głośność głosu.",

  "appearance.theme": "Motyw",
  "appearance.system": "Systemowy",
  "appearance.dark": "Ciemny",
  "appearance.light": "Jasny",
  "appearance.channelList": "Lista kanałów",
  "appearance.compact": "Tryb kompaktowy",
  "appearance.compactHint": "Ciaśniejsze wiersze, by zmieścić więcej kanałów i użytkowników.",

  "identity.profile": "Profil",
  "identity.away": "Komunikat nieobecności",
  "identity.awayHint": "Widoczny obok Twojego pseudonimu. Zostaw puste, by być dostępnym.",
  "identity.title": "Twoja tożsamość",
  "identity.description":
    "Twoja tożsamość to klucz zapisany w tej przeglądarce. Serwery rozpoznają Cię po nim, więc grupy i uprawnienia są do niego przypisane. Nie ma konta ani hasła.",
  "identity.uid": "Identyfikator użytkownika",
  "identity.publicKey": "Klucz publiczny",
  "identity.backup": "Kopia zapasowa",
  "identity.backupHint": "Wyeksportuj tożsamość, aby ją zachować lub użyć w innej przeglądarce albo aplikacji desktopowej.",
  "identity.export": "Eksportuj tożsamość",
  "identity.import": "Importuj tożsamość",
  "identity.importWarning": "Plik eksportu zawiera Twój klucz prywatny. Zachowaj go w tajemnicy. Import zastępuje tożsamość w tej przeglądarce.",
  "identity.imported": "Zaimportowano tożsamość. Połącz się ponownie, aby jej użyć.",
  "identity.importFailed": "To nie jest prawidłowa kopia zapasowa tożsamości.",

  "security.fingerprint": "Odcisk klucza serwera",
  "security.fingerprintHelp": "Porównaj go z właścicielem serwera, aby upewnić się, że łączysz się z właściwym serwerem.",
  "ss.ownership": "Właściciel",
  "own.none": "Ten serwer nie ma jeszcze właściciela. Operator wskazuje go poleceniem `gwar-server owner set` albo zostaje nim osoba, która użyje pierwszego tokenu admina.",
  "own.verifying": "Sprawdzanie zapisu właściciela…",
  "own.owner": "Właściciel",
  "own.verified": "Sprawdzone przez to urządzenie z zapisem właściciela, który przechowuje dla tego serwera.",
  "own.confirmers": "Zatwierdzający",
  "own.confirmersHint": "Zatwierdzający mogą dodawać i usuwać zarządców szyfrowanych prywatnych kanałów. Wyznacza ich tylko właściciel.",
  "own.saveConfirmers": "Zapisz zatwierdzających",
  "own.managers": "Zarządcy",
  "own.managersHint": "Zarządcy mogą tworzyć i zmieniać szyfrowane prywatne kanały. Lista podąża za tym, kto może edytować kanały, po potwierdzeniu przez właściciela albo zatwierdzającego.",
  "own.pending": "Czekają na potwierdzenie",
  "own.allow": "Pozwól",
  "own.remove": "Usuń",
  "own.nobody": "Nikt",
  "own.signedBy": "Listę podpisał(a) {name}, {date}.",
  "own.transfer": "Przekaż własność",
  "own.transferHint": "Nowy właściciel dostaje rolę Admina i decyduje, kto zatwierdza zarządców. Twoje role zostają. Sam(a) nie cofniesz tej zmiany.",
  "own.transferTo": "Nowy właściciel",
  "own.transferConfirm": "Ustaw {name} jako właściciela",
  "own.password": "Hasło konta",
  "own.passwordHint": "Podpisuje to klucz konta właściciela, więc potrzebne jest hasło Gwar Connect.",
  "own.staleTitle": "Zatwierdzający bez prawa edycji kanałów",
  "own.staleBody": "{names} nie może już edytować kanałów, ale nadal może zatwierdzać zarządców. Usuń ich w Ustawieniach serwera → Właściciel (zmianę podpisuje hasło Twojego konta).",
  "own.open": "Otwórz",
  "own.allowTitle": "Nowy zarządca",
  "own.allowBody": "Pozwolić {name} zarządzać prywatnymi kanałami?",
  "owner.changed": "Zapis właściciela tego serwera zmienił się w sposób, który nie jest możliwy. Rozłączono: to może nie być serwer, który znasz.",
  "owner.newTitle": "Serwer ma nowego właściciela",
  "owner.newBody": "Operator serwera ustanowił {name} nowym właścicielem, na przykład po utracie konta przez poprzedniego. Zaakceptować zmianę? Prywatne kanały będą wtedy wymagać potwierdzenia nowego właściciela.",
  "owner.accept": "Akceptuj",
  "security.changedTitle": "Tożsamość serwera się zmieniła",
  "security.changedBody": "Tożsamość tego serwera się zmieniła. Może to oznaczać inny serwer lub atak. Przed zaufaniem nowemu kluczowi sprawdź odcisk u właściciela serwera.",
  "security.inviteMismatch": "Klucz serwera nie pasuje do zaproszenia. Połączenie jest zablokowane. Uzyskaj zaufane zaproszenie od właściciela serwera.",
  "security.oldKey": "Oczekiwany klucz",
  "security.newKey": "Przedstawiony klucz",
  "security.trustDanger": "Niebezpieczne: zapomnij stary klucz i zaufaj nowemu",
  "security.insecureLan": "Niezabezpieczone połączenie (LAN)",
  "security.insecureWarning": "To połączenie nie jest szyfrowane: każdy w sieci może podszyć się pod serwer lub przejąć Twoją sesję",

  "server.menu": "Menu serwera",
  "server.switchTitle": "Otworzyć inny serwer?",
  "server.switchBody": "Opuścić rozmowę na serwerze {from}, aby otworzyć {to}?",
  "server.switchConfirm": "Opuść i otwórz",
  "server.reconnecting": "Łączenie ponownie…",
  "server.settings": "Ustawienia serwera",
  "server.createChannel": "Utwórz kanał",
  "server.createToken": "Utwórz token zaproszenia",
  "server.redeem": "Wykorzystaj token",
  "server.copyAddress": "Kopiuj adres serwera",
  "server.key": "Klucz serwera",
  "server.disconnect": "Rozłącz z serwerem",
  "serverSettings.name": "Nazwa serwera",
  "serverSettings.welcome": "Wiadomość powitalna",
  "serverSettings.welcomeHint": "Widoczna dla każdego, kto dołącza.",

  "toast.copied": "Skopiowano",
  "toast.copyFailed": "Nie udało się skopiować do schowka.",

  "tree.label": "Kanały i użytkownicy",
  "tree.empty": "Brak kanałów",
  "tree.emptyHint": "Kanały utworzone na tym serwerze pojawią się tutaj.",
  "tree.locked": "Chroniony hasłem",
  "tree.join": "Dołącz do kanału",
  "tree.joinVoice": "Dołącz do głosu",
  "tree.joinVoiceNamed": "Dołącz do głosu w {name}",
  "tree.openChat": "Otwórz czat",
  "tree.inVoice": "jesteś tu na głosie",
  "tree.unread": "{count} nieprzeczytanych",
  "tree.createSub": "Utwórz podkanał",
  "tree.edit": "Edytuj kanał",
  "tree.deleteTitle": "Usunąć „{name}”?",
  "tree.deleteBody": "Podkanały też zostaną usunięte. Osoby w środku trafią do kanału domyślnego.",
  "tree.away": "nieobecny",
  "tree.muted": "Wyciszony mikrofon",
  "tree.deafened": "Wyciszony dźwięk",
  "tree.volume": "Głośność",
  "tree.volumeReset": "Przywróć 100%",
  "tree.pm": "Wyślij wiadomość prywatną",
  "tree.moveHere": "Przenieś do mojego kanału",
  "tree.kickTitle": "Wyrzucić {name}?",
  "tree.kickBody": "Zostanie rozłączony z serwerem, ale może od razu połączyć się ponownie.",
  "tree.kick": "Wyrzuć z serwera",
  "tree.kickChannel": "Wyrzuć z kanału",
  "tree.info": "Informacje o kanale",
  "tree.moveUp": "Przesuń w górę",
  "tree.moveDown": "Przesuń w dół",
  "tree.you": "To Ty",

  "channel.createTitle": "Utwórz kanał",
  "channel.editTitle": "Edytuj kanał",
  "channel.name": "Nazwa",
  "channel.topic": "Temat",
  "channel.parent": "Kanał nadrzędny",
  "channel.noParent": "Brak (najwyższy poziom)",
  "channel.password": "Hasło",
  "channel.passwordNone": "Zostaw puste dla kanału otwartego.",
  "channel.passwordKeep": "Zostaw puste, aby zachować obecne hasło.",
  "channel.passwordWillRemove": "Hasło zostanie usunięte.",
  "channel.private": "Prywatny",
  "channel.privateHint": "Kanał widzą tylko wybrane role i osoby oraz administratorzy. Użytkownicy TeamSpeaka go nie widzą.",
  "channel.access": "Kto widzi ten kanał",
  "channel.accessHint": "Administratorzy zawsze widzą kanały prywatne.",
  "channel.accessRoles": "Role",
  "channel.accessMembers": "Członkowie",
  "channel.membersHint": "Szyfrowany: czytać mogą tylko te osoby, według listy członków, którą podpisujesz. Właściciel, potwierdzający i managerowie mają dostęp zawsze.",
  "channel.addRole": "Dodaj wszystkich z rolą {role}",
  "channel.membersSigned": "Listę członków podpisał(a) {name}, {date}",
  "channel.membersAuthority": "Szyfrowany kanał prywatny mogą tworzyć i edytować tylko właściciel serwera, potwierdzający i managerowie (Ustawienia serwera → Własność).",
  "channel.membersLoading": "Wczytywanie podpisanej listy członków…",
  "channel.accessFilter": "Filtruj członków",
  "tree.private": "Kanał prywatny",
  "tree.full": "Kanał jest pełny",
  "tree.limit": "Limit miejsc: {max}",
  "tree.familyLimit": "{count} z {max} miejsc na tym kanale i w jego podkanałach",
  "chinfo.topic": "Temat",
  "chinfo.description": "Opis",
  "chinfo.noDescription": "Brak opisu.",
  "chinfo.loading": "Wczytywanie opisu…",
  "chinfo.limit": "Limit miejsc",
  "chinfo.familyLimit": "Limit razem z podkanałami",
  "chinfo.none": "Brak",
  "chinfo.password": "Hasło",
  "chinfo.passwordRequired": "Wymagane",
  "poke.action": "Szturchnij…",
  "poke.title": "{name} szturcha Cię",
  "poke.received": "{name} szturcha Cię: {message}",
  "poke.receivedEmpty": "{name} szturcha Cię",
  "poke.dialogTitle": "Szturchnij: {name}",
  "poke.dialogBody": "Szturchnięcie od razu wyskoczy tej osobie, razem z Twoją wiadomością.",
  "poke.message": "Wiadomość",
  "poke.send": "Szturchnij",
  "poke.sent": "Szturchnięto: {name}",
  "tree.default": "Kanał domyślny",
  "channel.encrypted": "Szyfrowanie end-to-end",
  "channel.encryptedHint": "Wiadomości mogą przeczytać tylko urządzenia członków. Użytkownicy TeamSpeaka nie mogą dołączyć.",
  "channel.history": "Nowi członkowie widzą wcześniejsze wiadomości",
  "channel.historyHint": "Urządzenia członków udostępniają wcześniejsze wiadomości osobom, które dołączą później.",
  "channel.encryptionPermanent": "Tych opcji nie da się zmienić po utworzeniu kanału.",
  "channel.readers": "Kto może czytać",
  "chat.serverReadersHint": "Urządzenia w grupie tej rozmowy, tak jak widzi ją to urządzenie.",
  "chat.serverReadersPending": "Ta rozmowa jest jeszcze zabezpieczana na tym urządzeniu.",
  "channel.readersHint": "Urządzenia w grupie tego kanału, tak jak widzi ją to urządzenie.",
  "channel.hearers": "Kto może słyszeć",
  "channel.hearersHint": "Urządzenia w grupie głosowej tej rozmowy, tak jak widzi ją to urządzenie.",
  "channel.hearersJoin": "Dołącz do rozmowy, żeby zobaczyć, kto może słyszeć.",
  "channel.hearersPending": "Ta rozmowa jest jeszcze zabezpieczana na tym urządzeniu.",
  "channel.readersPending": "Ten kanał jest jeszcze zabezpieczany na tym urządzeniu.",
  "channel.devices.one": "{count} urządzenie",
  "channel.devices.other": "{count} urządzenia",
  "channel.devices.few": "{count} urządzenia",
  "channel.devices.many": "{count} urządzeń",
  "chat.messagesEncrypted": "Wiadomości są szyfrowane end-to-end",
  "chat.historyNotShared": "Wcześniejsze wiadomości nie są udostępniane nowym członkom.",
  "chat.restarted": "Ta rozmowa została uruchomiona od nowa.",
  "channel.removePassword": "Usuń hasło",
  "channel.maxClients": "Maks. użytkowników",
  "channel.maxHint": "Puste = bez limitu.",
  "channel.maxInvalid": "Maksymalna liczba użytkowników musi być liczbą od 1 do 1000.",
  "channelPassword.title": "Dołącz do „{name}”",
  "channelPassword.description": "Ten kanał jest chroniony hasłem.",
  "channelPassword.wrong": "Nieprawidłowe hasło.",

  "redeem.title": "Wykorzystaj token",
  "redeem.description": "Wklej token zaproszenia lub administratora, aby otrzymać jego uprawnienia.",
  "redeem.token": "Token",
  "redeem.submit": "Wykorzystaj",
  "redeem.success": "Token wykorzystany. Twoje grupy: {groups}.",
  "redeem.invalid": "Ten token jest nieprawidłowy lub został już użyty.",
  "token.title": "Utwórz token zaproszenia",
  "token.description": "Osoba, która wykorzysta token, dołączy do wybranej grupy. Każdy token działa raz.",
  "token.group": "Grupa",
  "token.create": "Utwórz token",
  "token.created": "Przekaż ten token osobie, którą chcesz zaprosić:",
  "token.once": "Po zamknięciu tego okna nie będzie można go ponownie wyświetlić.",

  "voice.mute": "Wycisz mikrofon",
  "voice.unmute": "Włącz mikrofon",
  "voice.deafen": "Wyłącz dźwięk (wycisza dźwięk i mikrofon)",
  "voice.undeafen": "Włącz dźwięk",
  "voice.connected": "Głos połączony",
  "voice.connecting": "Łączenie głosu…",
  "voice.reconnecting": "Łączenie ponownie…",
  "voice.failed": "Głos niedostępny",
  "voice.retry": "Ponów",
  "voice.why": "Dlaczego?",
  "voice.retryMic": "Spróbuj ponownie",
  "voice.openPrivacySettings": "Otwórz ustawienia prywatności",
  "voice.leave": "Opuść kanał głosowy",
  "voice.pill": "Połączenie głosowe",
  "voice.pillOpen": "Przejdź do kanału głosowego",
  "voice.quality.good": "Dobre połączenie",
  "voice.quality.fair": "Średnie połączenie",
  "voice.quality.poor": "Słabe połączenie",
  "voice.quality.upload": "Wysyłanie nie nadąża",
  "voice.quality.open": "{quality} · {ms} ms. Pokaż szczegóły",
  "voice.quality.title": "Jakość połączenia",
  "voice.quality.notice": "Twój internet nie nadąża z wysyłaniem — inni słyszą Cię z opóźnieniem ok. {delay} s.",
  "voice.quality.showDetails": "Szczegóły",
  "screen.quality.goodExplain": "Udostępnianie ekranu działa bez zauważalnego opóźnienia.",
  "screen.quality.uploadExplain": "Twój internet nie nadąża z wysyłaniem udostępnianego ekranu. Obraz może się opóźniać lub zacinać.",
  "screen.quality.slowExplain": "Połączenie z serwerem jest wolne lub niestabilne, więc udostępniany ekran może się opóźniać lub zacinać.",
  "screen.quality.uploadTech": "Kolejka wysyłanych danych w routerze lub modemie może opóźniać udostępniany ekran. Włącz SQM lub QoS (np. CAKE albo fq_codel) z limitem wysyłania nieco poniżej prędkości łącza. Gwar wnioskuje o tym ze wzrostu opóźnienia; nie wie, która aplikacja wysyła dane.",
  "voice.quality.none": "Brak pomiarów.",
  "voice.quality.goodExplain": "Wszystko działa dobrze: inni słyszą Cię bez zauważalnego opóźnienia.",
  "voice.quality.uploadExplain": "Twój internet nie nadąża z wysyłaniem, więc inni słyszą Cię z opóźnieniem ok. {delay} s. Zwykle dzieje się tak, gdy coś innego na tym urządzeniu lub w tej sieci wysyła dużo danych.",
  "voice.quality.uploadFix": "Zatrzymaj wysyłanie plików, kopię zapasową, synchronizację z chmurą lub inną rozmowę na tym urządzeniu lub w tej sieci. Pobieranie zwykle działa normalnie.",
  "voice.quality.slowExplain": "Połączenie z serwerem jest wolne lub niestabilne, więc głos może się opóźniać lub przerywać.",
  "voice.quality.slowFix": "Jeśli możesz, podłącz się kablem lub podejdź bliżej routera Wi-Fi i zamknij inne aplikacje korzystające z internetu.",
  "voice.quality.technical": "Szczegóły techniczne",
  "voice.quality.ping": "Opóźnienie do serwera (w obie strony)",
  "voice.quality.usual": "Zwykle",
  "voice.quality.loss": "Utrata pakietów",
  "voice.quality.uploadRate": "Szacowana prędkość wysyłania",
  "voice.quality.uploadTech": "To tzw. bufferbloat: kolejka w routerze lub modemie zapełnia się danymi, które wysyła inna aplikacja, a głos czeka za nimi. Jeśli zdarza się to często, włącz na routerze SQM lub QoS (np. CAKE albo fq_codel) z limitem wysyłania nieco poniżej prędkości łącza. Gwar wnioskuje o tym ze wzrostu opóźnienia; nie wie, która aplikacja wysyła dane.",
  "voice.notIn": "Poza kanałem głosowym",
  "voice.notInHint": "Kliknij kanał dwukrotnie, aby rozmawiać",
  "voice.pttHint": "Naciśnij i mów: przytrzymaj {key}",
  "voice.encryptedUnsupported": "Zaktualizuj przeglądarkę albo użyj aplikacji na komputer, żeby dołączyć do szyfrowanej rozmowy.",
  "voice.securing": "Zabezpieczanie głosu…",
  "voice.channelSecuring": "Ten szyfrowany kanał jest jeszcze zabezpieczany na tym urządzeniu. Spróbuj za chwilę.",
  "voice.securingTimeout": "Nie udało się zabezpieczyć szyfrowanej rozmowy. Spróbuj ponownie.",
  "voice.closed": "Połączenie głosowe zostało zamknięte. Łączenie ponownie…",
  "voice.deviceSwitched": "Przełączono na: {device}",
  "screen.share": "Udostępnij ekran",
  "screen.stop": "Zakończ udostępnianie",
  "screen.encryptedSoon": "Udostępnianie ekranu na kanałach szyfrowanych już wkrótce.",
  "screen.unsupported": "Ta przeglądarka nie potrafi udostępnić ekranu.",
  "screen.insecure": "Udostępnianie ekranu wymaga bezpiecznego połączenia (https).",
  "screen.needsMacos": "Udostępnianie ekranu wymaga systemu macOS 14.6 lub nowszego.",
  "screen.desktopSoon": "Udostępnianie ekranu w aplikacji na komputer już wkrótce. Na razie użyj przeglądarki.",
  "screen.noPermission": "Nie możesz udostępniać ekranu na tym kanale.",
  "screen.channelFull": "Na tym kanale jest już tyle udostępnień ekranu, ile wolno.",
  "screen.alreadySharing": "Już udostępniasz ekran.",
  "screen.reconnectStopped": "Udostępnianie ekranu przerwało się po utracie połączenia.",
  "screen.reconnectStoppedShort": "Udostępnianie przerwane",
  "screen.shareAgainShort": "Udostępnij",
  "screen.watchReconnecting": "Przywracanie podglądu…",
  "screen.reconnecting": "Przywracanie udostępniania…",
  "screen.permission": "Zezwól na nagrywanie ekranu dla {app} w {settings}.",
  "screen.permissionHint": "Jeśli wybór został anulowany, pomiń tę wskazówkę. W przeciwnym razie zezwól na nagrywanie ekranu dla {app} w ustawieniach prywatności systemu lub przeglądarki.",
  "screen.permissionTitle": "Brak zgody na nagrywanie ekranu",
  "screen.permissionShort": "Brak dostępu do ekranu",
  "screen.permissionFix": "Jak włączyć",
  "screen.permissionHintTitle": "Nie udało się udostępnić ekranu",
  "screen.permissionHintShort": "Nie udało się udostępnić",
  "screen.permissionHintFix": "Jak naprawić",
  "screen.permissionPlace.macos": "Ustawieniach systemowych → Prywatność i ochrona → Nagrywanie ekranu i dźwięku systemowego",
  "screen.permissionPlace.windows": "Ustawieniach → Prywatność i zabezpieczenia",
  "screen.permissionPlace.other": "ustawieniach prywatności systemu lub przeglądarki",
  "screen.openSettings": "Otwórz ustawienia",
  "screen.publishFailed": "Nie udało się rozpocząć udostępniania. Spróbuj ponownie.",
  "screen.browser": "Twojej przeglądarki",
  "screen.captureFailed": "Nie udało się udostępnić ekranu. Spróbuj wybrać inne okno.",
  "screen.presetTitle": "Udostępnij ekran",
  "screen.stopShort": "Zakończ",
  "screen.playAudio": "Odtwórz dźwięk transmisji",
  "screen.audioSharing": "Udostępniasz dźwięk karty.",
  "screen.computerSound": "Udostępniaj dźwięk komputera",
  "screen.computerSoundHint": "Widzowie usłyszą to, co słyszysz Ty, poza dźwiękami z Gwar.",
  "screen.computerSoundSharing": "Udostępniasz dźwięk komputera, bez dźwięków z Gwar.",
  "screen.computerSoundReady": "Dźwięk komputera będzie udostępniany, bez dźwięków z Gwar.",
  "screen.computerSoundOff": "Dźwięk komputera nie jest udostępniany.",
  "screen.computerSoundStopped": "Dźwięk komputera jest wyłączony dla tej transmisji. Aby go włączyć, rozpocznij nową.",
  "screen.computerSoundOffLive": "Dźwięk komputera jest wyłączony. Obraz udostępniasz dalej.",
  "screen.computerSoundResuming": "Przywracamy dźwięk komputera. Obraz udostępniasz dalej.",
  "screen.computerSoundFailed": "Dźwięk komputera jest niedostępny, więc udostępniasz sam obraz.",
  "screen.computerSoundUnsupported": "Dźwięk komputera wymaga macOS 14 lub Windows 11 albo nowszego systemu. Udostępniasz sam obraz.",
  "screen.computerSoundPermission": "Włącz Gwar w Ustawieniach systemowych → Prywatność i ochrona → Nagrywanie ekranu i dźwięku systemowego, a potem uruchom Gwar ponownie.",
  "screen.computerSoundPermissionLive": "Włącz Gwar w Ustawieniach systemowych → Prywatność i ochrona → Nagrywanie ekranu i dźwięku systemowego i wróć tutaj. Jeśli dźwięk się nie włączy, pomoże ponowne uruchomienie Gwar, ale zakończy to tę transmisję.",
  "screen.stopComputerSound": "Przestań udostępniać dźwięk",
  "screen.soundTurnOn": "Włącz dźwięk",
  "screen.soundTurningOn": "Włączanie dźwięku",
  "screen.soundFailed": "Nie udało się włączyć dźwięku. Obraz udostępniasz dalej.",
  "screen.audioAddHint": "Udostępniasz sam obraz. Wybierz kartę przeglądarki, aby dodać jej dźwięk. Obraz się nie zmieni.",
  "screen.audioChooseTab": "Wybierz kartę",
  "screen.audioServer": "Dźwięk transmisji nie jest dostępny na tym serwerze.",
  "screen.audioReady": "Dźwięk karty będzie udostępniany.",
  "screen.audioUnavailable": "Ten wybór nie ma dźwięku. Wybierz kartę przeglądarki i włącz jej dźwięk.",
  "screen.audioOn": "Z dźwiękiem",
  "screen.sharingAudio": "Udostępniasz z dźwiękiem",
  "screen.audioResuming": "Przywracanie dźwięku",
  "screen.audioOff": "Bez dźwięku",
  "screen.shareVolume": "Głośność transmisji",
  "screen.muteAudio": "Wycisz transmisję",
  "screen.unmuteAudio": "Włącz dźwięk transmisji",
  "screen.presetHint": "Wybierz, co jest najważniejsze. Możesz to zmienić w trakcie.",
  "screen.surface.screen": "Udostępniasz cały ekran",
  "screen.surface.window": "Udostępniasz okno",
  "screen.surface.tab": "Udostępniasz kartę przeglądarki",
  "screen.surface.unknown": "Udostępniasz ekran",
  "screen.preset": "Jakość",
  "screen.mode": "Tryb",
  "screen.mode.smooth": "Płynność",
  "screen.mode.sharp": "Ostry tekst",
  "screen.resolution": "Rozdzielczość",
  "screen.frameRate": "Liczba klatek",

  "screen.start": "Udostępnij",
  "screen.sharingBar": "Udostępniasz ekran",
  "screen.watching.one": "{count} osoba ogląda",
  "screen.watching.few": "{count} osoby oglądają",
  "screen.watching.many": "{count} osób ogląda",
  "screen.watching.other": "{count} osoby oglądają",
  "screen.starting": "Uruchamianie…",
  "screen.preview": "Podgląd",
  "screen.limitedCpu": "Ograniczone przez ten komputer",
  "screen.limitedBandwidth": "Ograniczone przez łącze",
  "screen.encoder": "Enkoder: {name} ({kind})",
  "screen.encoderHardware": "sprzętowy",
  "screen.encoderSoftware": "programowy",
  "screen.encoderUnknown": "typ nieznany",
  "screen.live": "NA ŻYWO",
  "screen.liveTitle": "{name} udostępnia ekran. Kliknij, aby oglądać.",
  "screen.liveSelf": "Udostępniasz ekran",
  "screen.liveDesktop": "{name} udostępnia ekran. Na razie oglądanie wymaga przeglądarki.",
  "screen.watch": "Oglądaj",
  "screen.stopWatching": "Przestań oglądać",
  "screen.fullscreen": "Pełny ekran",
  "screen.exitFullscreen": "Zamknij pełny ekran",
  "screen.pip": "Obraz w obrazie",
  "screen.showChat": "Pokaż czat",
  "screen.hideChat": "Ukryj czat",
  "screen.stage": "Udostępnione ekrany",
  "screen.sharerTitle": "Ekran: {name}",
  "screen.connecting": "Łączenie z udostępnieniem…",
  "screen.pausedBandwidth": "Twoje łącze nie nadąża, więc obraz wstrzymano, żeby głos się nie rwał. Wróci sam.",
  "screen.pausedWaiting": "Twoje łącze nie nadąża, więc obraz wstrzymano. Gdy łącze się poprawi, kliknij »Spróbuj ponownie«.",
  "screen.pausedBudget": "Wstrzymano, aby zwolnić zasoby serwera. Oczekiwanie na wznowienie…",
  "screen.pausedShort": "Wstrzymano",
  "screen.pausedLink": "Wstrzymane – słabe łącze",
  "screen.retry": "Spróbuj ponownie",
  "screen.retryIn": "Ponowna próba za {seconds} s",
  "screen.retrying": "Ponawianie…",
  "screen.ended": "Udostępnianie ekranu się zakończyło.",
  "screen.noLongerWatch": "Nie możesz już oglądać tego udostępnienia.",
  "screen.joinToWatch": "Dołącz do tego kanału, aby oglądać jego udostępnienie.",
  "screen.slotLimit": "Możesz oglądać naraz do 4 udostępnień. Najpierw przestań oglądać jedno z nich.",
  "screen.viewerLimit": "To udostępnienie ma już tylu widzów, ilu wolno.",
  "screen.watchFailed": "Połączenie do oglądania udostępnień zostało zerwane.",
  "screen.stopped.moderator": "{name} zatrzymuje Twoje udostępnianie ekranu.",
  "screen.stopped.limit": "Twoje udostępnianie zatrzymano: wysyłało więcej, niż pozwala serwer.",
  "screen.stopped.transport": "Nie udało się połączyć udostępniania ekranu.",
  "screen.stopped.encoder": "Twoje udostępnianie zatrzymano: ta przeglądarka nie mogła zakodować obrazu.",
  "screen.stopped.budget": "Twoje udostępnianie zatrzymano: serwer nie ma już miejsca na udostępnienia.",
  "screen.cantDecode": "Twoja przeglądarka nie potrafi odkodować tego udostępnienia. Poproś udostępniającego o użycie zgodnej przeglądarki lub kodeka.",
  "screen.stopped.access": "Twoje udostępnianie zatrzymano: nie możesz już udostępniać na tym kanale.",
  "screen.stopOther": "Zatrzymaj udostępnianie",
  "screen.tsNotice": "Użytkownicy TeamSpeaka na tym kanale mogą oglądać przez link. Oglądać może każdy, kto ma ten link.",
  "screen.tsPost": "Wyślij na TeamSpeaka link do oglądania",
  "screen.tsLinkOn": "Link dla TeamSpeaka włączony",
  "screen.guests.one": "{count} gość",
  "screen.guests.few": "{count} gości",
  "screen.guests.many": "{count} gości",
  "screen.guests.other": "{count} gościa",
  "screen.tsTurnOff": "Wyłącz",
  "screen.tsTurnOffTitle": "Wyłącz link dla TeamSpeaka w tym udostępnianiu. Goście przestaną oglądać.",
  "screen.tsTurnOffOther": "Wyłącz link dla TeamSpeaka",

  "chat.today": "Dzisiaj",
  "chat.yesterday": "Wczoraj",
  "chat.serverWelcome": "Wiadomość powitalna serwera",
  "chat.messages": "Wiadomości",
  "chat.conversationBeginning": "To początek rozmowy.",
  "chat.beginning": "To początek historii kanału.",
  "chat.empty": "Brak wiadomości",
  "chat.emptyChannel": "Przywitaj się z wszystkimi na tym kanale. Wiadomości tutaj są zapisywane.",
  "chat.emptyChannelElsewhere": "TeamSpeak pokazuje wiadomości z kanału tylko osobom, które na nim są. Dołącz do kanału, aby tu czytać i pisać.",
  "chat.emptyChannelNoHistory": "Przywitaj się z wszystkimi na tym kanale. Serwery TeamSpeak nie przechowują historii wiadomości, więc widać je tylko, gdy jesteś połączony.",
  "chat.emptyServer": "Wiadomości tutaj trafiają do wszystkich na serwerze i nie są zapisywane.",
  "chat.emptyServerHistory": "Wiadomości tutaj trafiają do wszystkich na serwerze i są zapisywane.",
  "chat.emptyDm": "Prywatne wiadomości widzicie tylko wy dwoje i nie są zapisywane.",
  "chat.jump": "Przejdź do najnowszych",
  "chat.compose": "Wiadomość",
  "chat.placeholderChannel": "Napisz na #{name}",
  "chat.placeholderServer": "Napisz do wszystkich na serwerze",
  "chat.placeholderDm": "Napisz do {name}",
  "chat.peerOfflineNamed": "{name} jest offline",
  "chat.peerOffline": "Ten użytkownik nie jest już połączony.",
  "chat.send": "Wyślij wiadomość",
  "chat.closeDm": "Zamknij rozmowę",
  "chat.conversations": "Rozmowy",
  "chat.channel": "Kanał",
  "chat.server": "Serwer",
  "chat.noTopic": "Brak tematu",
  "chat.serverHint": "Wszyscy na serwerze {name}",
  "chat.securing": "Zabezpieczanie rozmowy…",
  "chat.waitingManager": "Czekamy, aż manager kanału potwierdzi dostęp…",
  "chat.cannotOpen": "Nie można otworzyć tej wiadomości na tym urządzeniu",
  "chat.noKeyReason": "To urządzenie nie ma jeszcze klucza do tej wiadomości.",
  "chat.cannotOpenReason": "Nie udało się potwierdzić autentyczności tej wiadomości.",
  "chat.waitingHistory": "Wcześniejsze wiadomości pojawią się, gdy inny uczestnik będzie online.",
  "chat.deleted": "Usunięto",
  "chat.encrypted": "Szyfrowanie end-to-end",
  "chat.notEncrypted": "Bez szyfrowania end-to-end",
  "chat.dmHint": "Rozmowa prywatna",
  "chat.users.one": "{count} osoba na głosie",
  "chat.users.other": "{count} osoby na głosie",
  "chat.users.few": "{count} osoby na głosie",
  "chat.users.many": "{count} osób na głosie",
  "chat.members": "Członkowie",
  "chat.lockedTitle": "Kanał z hasłem",
  "chat.lockedHint": "Podaj hasło, aby dołączyć do kanału. Czat otworzy się, gdy już tam będziesz.",
  "chat.lockedAction": "Podaj hasło",
  "chat.placeholderLocked": "Ten kanał jest zablokowany",
  "chat.joiningShort": "Dołączanie",
  "chat.notSent": "Nie wysłano",
  "chat.locked": "Ten kanał jest chroniony hasłem",
  "chat.retry": "Wyślij ponownie",
  "chat.sending": "Wysyłanie…",
  "chat.maybeSent": "Mogła zostać wysłana lub usunięta",
  "chat.failed.lost": "Połączenie zostało przerwane.",
  "chat.failed.securing": "Rozmowa była jeszcze zabezpieczana.",
  "chat.failed.peerOffline": "Rozmówca był offline.",
  "chat.missingAttachments": "Dodaj plik ponownie, aby go wysłać.",
  "chat.dismiss": "Odrzuć",
  "chat.reconnecting": "Utracono połączenie. Łączenie ponownie…",

  "members.title": "Członkowie",
  "members.voice": "Na głosie",
  "members.online": "Online",
  "members.offline": "Offline",
  "members.admin": "Administrator",
  "members.lastSeen": "Ostatnio widziany(-a) {when}",
  "members.lastSeenUnknown": "Ostatnio widziany(-a): nieznane",
  "members.openChat": "Napisz do {name}",

  "sys.welcome": "{text}",
  "sys.user_joined_channel": "{name} dołącza do kanału",
  "sys.user_left_channel": "{name} opuszcza kanał",
  "sys.you_joined_channel": "Dołączasz do {name}",
  "sys.reconnected": "Połączono ponownie z serwerem",

  "err.connect.unreachable": "Nie można połączyć się z serwerem. Sprawdź adres i czy serwer działa.",
  "err.connect.timeout": "Serwer nie odpowiedział na czas. Spróbuj ponownie za chwilę.",
  "err.connect.password_required": "Serwer {server} wymaga hasła. Wpisz je poniżej, aby kontynuować.",
  "err.connect.wrong_password": "Nieprawidłowe hasło serwera. Spróbuj ponownie.",
  "err.connect.server_full": "Serwer jest teraz pełny. Spróbuj później.",
  "err.connect.rejected": "Serwer odrzucił połączenie. Sprawdź pseudonim i spróbuj ponownie.",
  "err.connect.certificate_expired": "Wpisz ponownie hasło do Gwar Connect na tym urządzeniu, aby się połączyć.",
  "err.connect.protocol": "Ten serwer używa innej wersji protokołu. Zaktualizuj klienta lub serwer.",
  "err.connect.storage_newer": "Nowsza wersja Gwar zapisała tożsamość lub logowanie tego urządzenia, a ta wersja nie potrafi ich odczytać. Niczego nie zmieniono: odśwież stronę albo zainstaluj najnowszy Gwar.",
  "err.connect.identity_unreadable": "Ta wersja Gwar nie potrafi odczytać tożsamości zapisanej na tym urządzeniu. Zostawiono ją bez zmian: zaktualizuj Gwar albo zaimportuj kopię w Ustawieniach → Tożsamość.",
  "err.connect.trust_storage": "Nie udało się odczytać ani zapisać kluczy serwerów zapamiętanych na tym urządzeniu, więc Gwar nie ufa teraz żadnemu kluczowi serwera. Odśwież stronę; jeśli zapisała je nowsza wersja Gwar, zaktualizuj ją.",
  "err.connect.identity_storage": "Nie udało się wczytać tożsamości zapisanej na tym urządzeniu, bo zawiódł jej magazyn danych. Odśwież stronę; jeśli to się powtarza, przeglądarka może blokować dane witryn.",
  "err.connect.identity": "Przeglądarka nie może tu utworzyć bezpiecznej tożsamości. Użyj aktualnej przeglądarki przez https (lub localhost).",
  "err.connect.address": "Ten adres serwera wygląda niepoprawnie.",
  "err.addr.empty": "Wpisz adres serwera.",
  "err.addr.invalid": "Ten adres serwera wygląda niepoprawnie.",
  "err.addr.scheme": "Obsługiwane są tylko adresy ws://, wss://, http:// i https://.",
  "err.addr.mixed_content": "Ten serwer nie używa HTTPS, więc aplikacja webowa nie może się z nim połączyć. Poproś jego właściciela o włączenie HTTPS albo użyj aplikacji desktopowej.",
  "err.addr.insecure": "Wymagany jest TLS. W aplikacji komputerowej możesz włączyć opcję „Niezabezpieczone połączenie (LAN)” dla tego serwera.",
  "err.connect.unreachableHttps": "Nie można połączyć się z serwerem. Sprawdź adres i czy serwer działa. Aplikacja webowa łączy się tylko z serwerami z HTTPS; jeśli ten go nie ma, poproś właściciela o włączenie go albo użyj aplikacji desktopowej.",

  "err.req.bad_request": "Nie udało się wykonać tej czynności. Sprawdź wpisane dane i spróbuj ponownie.",
  "err.req.not_authenticated": "Nie jesteś zalogowany.",
  "err.req.not_found": "To już nie istnieje.",
  "err.req.forbidden": "Nie masz uprawnień, aby to zrobić.",
  "err.req.wrong_password": "Nieprawidłowe hasło.",
  "err.req.channel_full": "Ten kanał jest pełny.",
  "err.req.rate_limited": "Robisz to zbyt szybko. Zwolnij trochę.",
  "err.req.conflict": "To koliduje z czymś, co już istnieje",
  "err.req.unavailable": "Serwer nie może tego teraz zrobić.",
  "err.req.internal": "Coś poszło nie tak po stronie serwera.",
  "err.req.timeout": "Serwer odpowiadał zbyt długo.",
  "err.req.lost": "Jesteś offline. Łączenie ponownie…",

  "err.voice.mic_denied": "Dostęp do mikrofonu jest zablokowany. Nadal możesz pisać i słuchać. Zezwól na mikrofon w ustawieniach witryny w przeglądarce, aby mówić.",
  "err.voice.mic_denied_desktop": "Dostęp do mikrofonu jest zablokowany. Nadal możesz pisać i słuchać. Zezwól aplikacji Gwar na mikrofon w ustawieniach prywatności systemu.",
  "err.voice.output_failed": "Nie udało się otworzyć głośników. Sprawdź urządzenie wyjściowe w ustawieniach.",
  "err.voice.no_mic": "Nie znaleziono mikrofonu. Nadal możesz pisać i słuchać.",
  "err.voice.mic_failed": "Nie udało się otworzyć mikrofonu (czy używa go inna aplikacja?). Nadal możesz pisać i słuchać.",
  "err.voice.mic_stop_failed": "Nie udało się wyłączyć mikrofonu na czas. Nagranie nie zostało odtworzone.",
  "err.voice.mic_stopping": "Mikrofon nadal się wyłącza. Spróbuj za chwilę.",
  "err.voice.insecure": "Przeglądarki zezwalają na mikrofon tylko przez https lub localhost. Nadal możesz pisać i słuchać.",
  "err.voice.negotiation": "Nie udało się nawiązać połączenia audio. Czat nadal działa.",
  "err.voice.unsupported": "Ta przeglądarka nie obsługuje głosu. Czat nadal działa.",

  "chat.edit": "Edytuj wiadomość",
  "chat.delete": "Usuń wiadomość",
  "chat.deleteTitle": "Usunąć tę wiadomość?",
  "chat.deleteBody": "Wiadomość zniknie dla wszystkich. Przytrzymaj Shift przy klikaniu usuwania, żeby pominąć to pytanie.",
  "chat.editing": "Edytuj wiadomość",
  "chat.editHint": "Enter zapisuje, Escape anuluje",
  "chat.notVerified": "Bez podpisu: ten serwer mógł podrobić lub zmienić tę wiadomość",
  "chat.invalid": "Niezweryfikowana",
  "chat.signatureInvalid": "Nieprawidłowy podpis lub adresat wiadomości",
  "chat.signatureValid": "Podpis prawidłowy",
  "chat.rollback": "Ponownie przesłano wcześniejszą wersję wiadomości (cofnięcie zmian)",
  "chat.fork": "Sprzeczne wersje wiadomości (rozwidlenie historii)",
  "chat.deviceRevoked": "urządzenie podpisujące zostało unieważnione; czas podpisania niepotwierdzony",
  "chat.certificateExpired": "certyfikat wygasł; czas podpisania niepotwierdzony",
  "chat.channelReused": "serwer ponownie użył identyfikatora wcześniej usuniętego kanału, więc ta wiadomość może pochodzić z usuniętego kanału",
  "chat.channelHistoryIncomplete": "ten klient nie mógł zachować pełnego zapisu usuniętych kanałów tego serwera, więc nie może wykluczyć ponownie użytego identyfikatora kanału",
  "chat.revocationsStale": "informacje o unieważnieniach są nieaktualne lub niedostępne",
  "chat.continuityUnproven": "ciągłość niepotwierdzona; to urządzenie nie ma zapisu wcześniejszych wersji, więc nie może wykryć cofnięcia zmian. Starsza historia usunięta z pamięci również nie ma tej ochrony",
  "chat.checkpointsUnavailable": "to urządzenie nie może teraz korzystać z pamięci lokalnej do sprawdzania wiadomości, więc nie wykryje cofnięcia zmian. Sprawdzenie zostanie powtórzone, gdy pamięć zacznie działać; jeśli problem się utrzymuje, przeglądarka może blokować dane witryn (na przykład w oknie prywatnym)",
  "chat.teamSpeakNotification": "TeamSpeak / bez podpisu",
  "chat.teamSpeakUnsigned": "Wiadomości TeamSpeak nie mają podpisu: ten serwer mógł podrobić lub zmienić tę wiadomość",
  "chat.serverRemoved": "Wiadomość usunięta przez serwer",
  "chat.authorDeleted": "Usunięta przez autora",
  "chat.unverifiedDeletion": "Niezweryfikowane żądanie usunięcia",
  "chat.verificationQueueFull": "Kolejka weryfikacji wiadomości jest pełna",
  "chat.replacementRejected": "Odrzucono zastąpienie wiadomości: nieprawidłowy podpis, cofnięcie zmian lub rozwidlenie historii",
  "chat.editInProgress": "Ta wiadomość jest już zmieniana",
  "chat.editChanged": "Wiadomość zmieniła się w międzyczasie; spróbuj ponownie",
  "chat.editUnverified": "Nie udało się zweryfikować tej wiadomości, więc nie można jej edytować ani usunąć Twoim podpisem",
  "chat.verifying": "Sprawdzanie podpisu…",
  "chat.edited": "(edytowano)",
  "chat.editedAt": "Edytowano {when}",
  "close.banned": "{by} zbanował(a) Cię na tym serwerze.",
  "close.bannedUntil": "Ban trwa do {when}.",
  "close.bannedReason": "Powód: {reason}",
  "err.connect.banned": "Masz bana na tym serwerze.",
  "err.connect.invite": "To zaproszenie jest nieprawidłowe, wygasło albo zostało wykorzystane. Poproś o nowe lub wpisz hasło serwera.",
  "err.req.banned": "Masz bana na tym serwerze.",
  "err.req.too_large": "To jest za duże.",
  "err.join.forbidden": "Nie masz uprawnień, aby dołączyć do tego kanału.",
  "err.req.quota_exceeded": "Brak miejsca na to na serwerze.",
  "err.req.partial": "Udało się tylko częściowo",
  "connect.invited": "Dostajesz zaproszenie na ten serwer. Połącz się, żeby dołączyć.",
  "connect.inviteForget": "Zignoruj zaproszenie",
  "file.attachment": "Załącznik",
  "file.missing": "Brak pliku",
  "file.attach": "Dołącz pliki",
  "file.attachInput": "Dołącz pliki",
  "file.pending": "Pliki do wysłania",
  "file.remove": "Usuń {name}",
  "file.dropHint": "Upuść pliki, aby je wysłać",
  "file.channelOnly": "Pliki można wysyłać tylko na czatach kanałów.",
  "file.disabled": "Wysyłanie plików nie jest tu dostępne.",
  "file.tooLarge": "Ten plik jest za duży. Limit to {limit}.",
  "file.quota": "Brak miejsca na pliki: osiągnięto limit Twoich plików albo całego serwera. Usunięcie wiadomości z plikami zwalnia miejsce.",
  "file.tooMany": "Do jednej wiadomości możesz dołączyć maksymalnie {max} plików.",
  "file.empty": "Ten plik jest pusty.",
  "file.forbidden": "Nie masz uprawnień do wysyłania plików.",
  "file.aborted": "Wysyłanie anulowane.",
  "file.networkFailed": "Nie udało się wysłać pliku. Sprawdź połączenie i spróbuj ponownie.",
  "file.notVerified": "Weryfikacja załącznika nie powiodła się",
  "file.loadFailed": "Nie udało się wczytać załącznika",
  "file.retry": "Spróbuj ponownie",
  "file.cannotOpen": "Nie można otworzyć tego pliku",
  "file.verifying": "Weryfikowanie załącznika…",
  "file.unverified": "Niezweryfikowany załącznik",
  "file.loadUnverified": "Wczytaj niezweryfikowany załącznik",
  "file.unverifiedRisk": "Serwer mógł podmienić lub zmienić ten załącznik. Otwórz go tylko wtedy, gdy ufasz jego źródłu.",
  "file.loadedUnverified": "Załącznik wczytany bez weryfikacji",
  "file.downloadUnverified": "Pobierz niezweryfikowany załącznik",
  "file.downloadUnverifiedNamed": "Pobierz niezweryfikowany załącznik: {name}",
  "file.download": "Pobierz",
  "file.downloadNamed": "Pobierz {name}",
  "file.open": "Otwórz {name}",
  "file.saveImage": "Zapisz obraz",
  "file.saved": "Zapisano {name}",
  "file.saveFailed": "Nie udało się zapisać pliku: {reason}",
  "mention.label": "Osoby do wspomnienia",
  "tree.mentions": "Wspomnienia o Tobie: {count}",
  "server.invite": "Zaproś ludzi",
  "settings.notifications": "Powiadomienia",
  "notify.when": "Powiadamiaj mnie o",
  "notify.mentions": "Wspomnieniach",
  "notify.mentionsHint": "Gdy ktoś napisze @twój pseudonim.",
  "notify.dms": "Wiadomościach prywatnych",
  "notify.dmsHint": "Gdy ktoś napisze do Ciebie bezpośrednio.",
  "notify.all": "Każdej wiadomości",
  "notify.allHint": "Cały czat kanałów i serwera. Może być uciążliwe.",
  "notify.backgroundOnly": "Powiadomienia pojawiają się tylko, gdy Gwar działa w tle.",
  "notify.permission": "Zgoda systemu",
  "notify.granted": "Powiadomienia są dozwolone.",
  "notify.denied": "Powiadomienia są zablokowane. Zezwól na nie w ustawieniach witryny w przeglądarce.",
  "notify.deniedDesktop": "Powiadomienia są zablokowane. Zezwól na nie dla Gwara w ustawieniach systemu.",
  "notify.allow": "Zezwól na powiadomienia",
  "notify.allowHint": "System zapyta o to jeden raz.",
  "notify.dm": "{name} (wiadomość prywatna)",
  "notify.channel": "{name} na #{channel}",
  "notify.server": "{name} na {server}",
  "mod.roles": "Role",
  "mod.noRoles": "Brak ról",
  "mod.roleBlocked": "Tylko role poniżej twojej, dla osób niżej od ciebie.",
  "mod.ban": "Zbanuj…",
  "mod.banNamed": "Zbanuj {name}",
  "mod.banTitle": "Zbanować {name}?",
  "mod.banBody": "Zostanie rozłączona od razu i nie wejdzie ponownie, dopóki ban nie wygaśnie lub nie zostanie zdjęty.",
  "mod.banned": "{name} dostaje bana.",
  "mod.reason": "Powód",
  "mod.reasonHint": "Opcjonalnie. Osoba go zobaczy.",
  "mod.duration": "Czas trwania",
  "mod.dur.1h": "1 godzina",
  "mod.dur.1d": "1 dzień",
  "mod.dur.7d": "7 dni",
  "mod.dur.perm": "Na stałe",
  "mod.alsoIp": "Zbanuj też jej adres IP",
  "mod.alsoIpHint": "Blokuje też inne konta z tego samego adresu.",
  "mod.alsoIpOffline": "Możliwe tylko, gdy osoba jest online.",
  "ss.overview": "Przegląd",
  "ss.roles": "Role",
  "ss.members": "Członkowie",
  "ss.bans": "Bany",
  "ss.invites": "Zaproszenia",
  "ss.readOnly": "Możesz to oglądać, ale nie zmieniać.",
  "ss.defaultChannel": "Kanał domyślny",
  "ss.defaultChannelHint": "Tu trafiają ludzie po wejściu na serwer.",
  "ss.maxClients": "Maks. użytkowników",
  "ss.maxClientsHint": "Ilu ludzi może być połączonych naraz.",
  "ss.maxInvalid": "Maks. użytkowników to liczba całkowita, co najmniej 1.",
  "ss.password": "Hasło serwera",
  "ss.passwordHint": "Zostaw puste, aby zachować obecne. Osoby z zaproszeniem go nie potrzebują.",
  "ss.passwordPlaceholder": "Nowe hasło",
  "ss.membersOnlyFiles": "Pliki tylko dla osób na serwerze",
  "ss.membersOnlyFilesHint": "Wyłączone: link do pliku otwiera każdy, kto go ma, a użytkownicy TeamSpeaka dostają linki. Włączone: pliki otwierają tylko osoby połączone z tym serwerem, które widzą dany kanał; użytkownicy TeamSpeaka widzą tylko nazwy plików.",
  "ss.screenGuestLinks": "Linki do oglądania dla TeamSpeaka",
  "ss.screenGuestLinksHint": "Udostępnianie ekranu na kanale TeamSpeaka może wysłać tam link, przez który użytkownicy TeamSpeaka oglądają je w przeglądarce. Udostępniający decyduje przy każdym udostępnianiu. Linki działają tylko wtedy, gdy pliki otwierają się przez link.",
  "ss.removePassword": "Usuń hasło serwera",
  "ss.createRole": "Utwórz rolę",
  "viewAs.titleRole": "Podgląd jako {name}",
  "viewAs.titleMember": "Podgląd jako {name}",
  "viewAs.body": "Kanały tak, jak je widzą, i co mogą w każdym z nich. Nic się nie zmienia.",
  "viewAs.role": "Rola",
  "viewAs.server": "Na całym serwerze",
  "viewAs.nothing": "Nic poza kanałami poniżej",
  "viewAs.channels": "Kanały",
  "viewAs.col.connect": "Wejście",
  "viewAs.col.speak": "Mówienie",
  "viewAs.col.send_messages": "Pisanie",
  "viewAs.col.attach_files": "Pliki",
  "viewAs.col.manage_channels": "Zarządzanie",
  "viewAs.yes": "Tak",
  "viewAs.no": "Nie",
  "viewAs.hidden": "Ukryte przed nimi kanały prywatne, które widzisz: {count}.",
  "viewAs.limits": "Kanały prywatne, których sam nie widzisz, nie są pokazane. Zaszyfrowany kanał prywatny wpuszcza tylko osoby z jego podpisanej listy (i jego menedżerów), nigdy na podstawie roli.",
  "viewAs.open": "Zobacz jako ta rola",
  "viewAs.openMember": "Zobacz serwer jako ten członek",
  "ss.builtin": "Rola wbudowana",
  "ss.roleName": "Nazwa roli",
  "ss.roleColor": "Kolor",
  "ss.noColor": "Bez koloru",
  "ss.pickColor": "Wybierz kolor",
  "ss.colorInvalid": "Podaj kolor w postaci #3498db.",
  "ss.permissions": "Uprawnienia",
  "ss.adminAll": "Admin ma uprawnienie administratora: zawsze wszystko.",
  "ss.roleOutranked": "Ta rola jest na twoim poziomie lub wyżej, więc nie możesz jej zmieniać.",
  "ss.deleteRoleTitle": "Usunąć rolę „{name}”?",
  "ss.deleteRoleBody": "Osoby, które ją mają, tracą ją razem z tym, na co pozwalała.",
  "ss.searchMembers": "Szukaj członków",
  "ss.noMembers": "Nikogo nie znaleziono",
  "ss.you": "Ty",
  "ss.editRoles": "Zmień role: {name}",
  "ss.noBans": "Brak aktywnych banów",
  "ss.noBansHint": "Zbanowane osoby pojawią się tu do końca bana.",
  "ss.noReason": "Bez podanego powodu",
  "ss.ipBan": "IP",
  "ss.bannedBy": "przez {by}",
  "ss.permanent": "Na stałe",
  "ss.expires": "kończy się {when}",
  "ss.unban": "Odbanuj",
  "ss.unbanned": "Ban zdjęty.",
  "invite.title": "Zaproś ludzi",
  "invite.description": "Udostępnij link. Każdy, kto go otworzy, może dołączyć do tego serwera.",
  "invite.maxUses": "Użycia",
  "invite.unlimited": "Bez limitu",
  "invite.expiry": "Wygasa",
  "invite.exp.30m": "Za 30 minut",
  "invite.exp.1h": "Za 1 godzinę",
  "invite.exp.1d": "Za 1 dzień",
  "invite.exp.7d": "Za 7 dni",
  "invite.exp.never": "Nigdy",
  "invite.role": "Rola dla nowych osób",
  "invite.noRole": "Bez dodatkowej roli",
  "invite.create": "Utwórz zaproszenie",
  "invite.server": "Serwer: {address}",
  "invite.none": "Brak zaproszeń",
  "invite.noneHint": "Utwórz zaproszenie, aby dostać link do udostępnienia.",
  "invite.list": "Zaproszenia",
  "invite.usesOf": "użyć: {uses} z {max}",
  "invite.usesCount": "użyć: {uses}",
  "invite.neverExpires": "nie wygasa",
  "invite.expired": "wygasło",
  "invite.by": "od {name}",
  "invite.copyLink": "Kopiuj link",
  "perm.section.server": "Serwer",
  "perm.section.channels": "Kanały",
  "perm.section.people": "Ludzie",
  "perm.section.chat": "Czat",
  "mod.muteAll": "Wycisz dla wszystkich",
  "mod.unmuteAll": "Cofnij wyciszenie",
  "mod.deafenAll": "Ogłusz dla wszystkich",
  "mod.undeafenAll": "Cofnij ogłuszenie",
  "tree.serverMuted": "Wyciszony przez moderatora",
  "tree.serverDeafened": "Ogłuszony przez moderatora",
  "voice.serverMuted": "Moderator cię wyciszył: nikt cię nie słyszy.",
  "voice.serverDeafened": "Moderator cię ogłuszył: nic nie słyszysz i nikt cię nie słyszy.",
  "voice.cannotSpeak": "Na tym kanale nie możesz mówić: nikt cię nie słyszy.",
  "perm.mute_members": "Wyciszanie ludzi",
  "perm.mute_members.hint": "Wyciszanie albo ogłuszanie kogoś dla wszystkich na kanale głosowym.",
  "perm.connect": "Wchodzenie na głos",
  "perm.connect.hint": "Dołączanie do rozmowy głosowej na kanale.",
  "perm.speak": "Mówienie",
  "perm.speak.hint": "Bycie słyszanym w rozmowie na kanale.",
  "perm.share_screen": "Udostępnianie ekranu",
  "perm.share_screen.hint": "Udostępnianie ekranu, okna albo karty w rozmowie na kanale.",
  "perm.send_messages": "Pisanie wiadomości",
  "perm.send_messages.hint": "Pisanie na czacie kanału (i na czacie serwera).",
  "perm.section.voice": "Głos",
  "chat.placeholderJoinToWrite": "Dołącz do kanału, aby tu pisać",
  "chat.placeholderNoWrite": "Nie możesz pisać na tym kanale.",
  "chperm.open": "Uprawnienia",
  "chperm.title": "Uprawnienia: {name}",
  "chperm.description": "Zezwól albo zabroń roli lub osobie robić coś na tym kanale. Zmiany działają od razu.",
  "chperm.synced": "Korzysta z uprawnień kanału {parent}.",
  "chperm.own": "Ma własne uprawnienia.",
  "chperm.unsync": "Ustaw własne",
  "chperm.sync": "Dziedzicz z {parent}",
  "chperm.editingSynced": "Każda zmiana tutaj nada kanałowi własne uprawnienia, zaczynając od tych z {parent}.",
  "chperm.targets": "Role i osoby",
  "chperm.add": "Dodaj rolę lub osobę…",
  "chperm.everyone": "Member (wszyscy)",
  "chperm.locked": "Zmieniać można tylko role poniżej twojej i osoby niżej od ciebie.",
  "chperm.deny": "Zabroń",
  "chperm.inherit": "Dziedzicz",
  "chperm.allow": "Zezwól",
  "chperm.whoJoins": "Na głos mogą wejść:",
  "perm.administrator": "Administrator",
  "perm.administrator.hint": "Wszystko i wszędzie. Ranga nadal obowiązuje: administrator działa tylko wobec osób niżej w kolejności ról.",
  "perm.manage_server": "Zarządzanie serwerem",
  "perm.manage_server.hint": "Zmiana nazwy, wiadomości powitalnej, hasła i innych ustawień serwera.",
  "perm.manage_roles": "Zarządzanie rolami",
  "perm.manage_roles.hint": "Tworzenie, edycja, kolejność i usuwanie ról poniżej własnej oraz nadawanie ich ludziom.",
  "perm.manage_members": "Zarządzanie członkami",
  "perm.manage_members.hint": "Zmiana pseudonimów innych, usuwanie członków i porządki wśród nieaktywnych. Każdy może zmienić własny pseudonim.",
  "perm.kick_members": "Wyrzucanie ludzi",
  "perm.kick_members.hint": "Rozłączanie ludzi z serwerem. Mogą wrócić.",
  "perm.ban_members": "Banowanie ludzi",
  "perm.ban_members.hint": "Zamykanie wstępu na jakiś czas lub na stałe oraz zdejmowanie banów.",
  "perm.create_invites": "Zapraszanie ludzi",
  "perm.create_invites.hint": "Linki z zaproszeniami i jednorazowe tokeny, dla ról poniżej własnej.",
  "perm.bypass_password": "Wchodzenie na kanały z hasłem",
  "perm.bypass_password.hint": "Wchodzenie i czytanie kanałów z hasłem bez jego znajomości.",
  "perm.attach_files": "Udostępnianie plików",
  "perm.attach_files.hint": "Dołączanie obrazów i plików do wiadomości.",
  "perm.manage_messages": "Usuwanie cudzych wiadomości",
  "perm.manage_messages.hint": "Usuwanie wiadomości napisanych przez innych.",
  "perm.move_members": "Przenoszenie ludzi",
  "perm.move_members.hint": "Przeciąganie ludzi na inne kanały.",
  "perm.manage_channels": "Zarządzanie kanałami",
  "perm.manage_channels.hint": "Tworzenie, edycja, przenoszenie i usuwanie kanałów.",
  "ss.rolesOrderHint": "Role wyżej mają wyższą rangę. Przeciągnij, by zmienić kolejność ról poniżej twojej.",
  "ss.yourRank": "twoja ranga",
  "ss.moveUp": "Przesuń wyżej",
  "ss.moveDown": "Przesuń niżej",
  "ss.roleDisplay": "Wyświetlanie",
  "ss.roleHoist": "Pokazuj osobno",
  "ss.roleHoistHint": "Osoby z tą rolą mają własną grupę na liście członków.",
  "ss.roleMentionable": "Pozwól na @wzmianki",
  "ss.roleMentionableHint": "Każdy może powiadomić wszystkich z tą rolą, pisząc @rola.",

  "settings.account": "Konto",
  "account.intro":
    "Gwar Connect to opcjonalne konto, które utrzymuje jedną tożsamość na wszystkich Twoich urządzeniach. Nigdy nie widzi Twojego hasła ani klucza: klucz jest przechowywany zaszyfrowany i otworzy go tylko hasło albo kod odzyskiwania.",
  "account.signInTitle": "Zaloguj się",
  "account.createTitle": "Załóż konto",
  "account.recoverTitle": "Odzyskaj kodem",
  "account.handle": "Nazwa konta",
  "account.handleHint": "3 do 32 znaków: a-z, 0-9, _ i .",
  "account.handleInvalid": "Nazwa konta ma 3 do 32 znaków: a-z, 0-9, _ i . (nie na początku ani na końcu).",
  "account.password": "Hasło",
  "account.currentPassword": "Obecne hasło",
  "account.newPassword": "Nowe hasło",
  "account.passwordConfirm": "Powtórz hasło",
  "account.passwordShort": "Użyj co najmniej {min} znaków.",
  "account.passwordMismatch": "Hasła nie są takie same.",
  "account.strength.weak": "Słabe hasło",
  "account.strength.fair": "Przeciętne hasło",
  "account.strength.strong": "Mocne hasło",
  "account.identityChoice": "Której tożsamości ma używać konto?",
  "account.keep": "Zachowaj moją obecną tożsamość",
  "account.keepHint": "Twoje role na serwerach zostają z Tobą. Wcześniej wyeksportowana kopia tożsamości pozostaje pełnym kluczem do konta, nawet po unieważnieniu tego urządzenia.",
  "account.fresh": "Zacznij od nowa",
  "account.freshHint": "Nowa tożsamość bez ról. Obecna zostaje na tym urządzeniu i wraca po wylogowaniu.",
  "account.create": "Załóż konto",
  "account.signIn": "Zaloguj się",
  "account.recover": "Odzyskaj konto",
  "account.forgot": "Nie pamiętasz hasła? Odzyskaj kodem",
  "account.haveAccount": "Masz już konto? Zaloguj się",
  "account.noAccount": "Pierwszy raz tutaj? Załóż konto",
  "account.back": "Wstecz",
  "account.recoveryTitle": "Zapisz kod odzyskiwania",
  "account.recoveryBody":
    "Ten kod to jedyny sposób powrotu na konto, gdy zapomnisz hasła. Pokazujemy go raz. Zachowaj go w bezpiecznym miejscu, na przykład w menedżerze haseł.",
  "account.recoveryCode": "Kod odzyskiwania",
  "account.recoveryCodeHint": "Wielkość liter, spacje i myślniki nie mają znaczenia.",
  "account.recoveryDownload": "Pobierz",
  "account.recoverySaved": "Zapisałem kod odzyskiwania",
  "account.recoverySavedNew": "Zapisałem nowy kod odzyskiwania",
  "account.recoveryChange": "Zmień kod odzyskiwania",
  "account.recoveryChangeHint": "Najpierw pokazuje nowy kod; stary przestaje działać, gdy potwierdzisz hasłem.",
  "account.recoveryChanged": "Kod odzyskiwania zmieniony. Stary już nie działa.",
  "account.recoveryContinue": "Dalej",
  "account.recoveryCreating": "Konto @{handle} powstanie po naciśnięciu „Dalej”. Nic jeszcze nie zostało wysłane.",
  "account.recoveryHandle": "Wybierz inną nazwę konta. Kod odzyskiwania pozostaje ten sam.",
  "account.signedIn": "Zalogowano jako @{handle}. Połącz się ponownie z serwerami, aby tego użyć.",
  "account.signedOut": "Wylogowano. Wróciła Twoja lokalna tożsamość.",
  "account.signedInAs": "Zalogowano jako @{handle}",
  "account.connectEntry": "Zaloguj się przez Gwar Connect",
  "account.connectEntryHint": "Miej jedną tożsamość na wszystkich urządzeniach.",
  "account.accountKey": "Klucz konta",
  "account.thisDevice": "To urządzenie",
  "account.devices": "Urządzenia",
  "account.devicesHint": "Nazwy i aktywność podaje Connect; lista może być niepełna. Urządzenia rozpoznajesz po ich kluczach.",
  "account.archive": "Kopia kluczy wiadomości",
  "account.archiveUploads": "Kopia kluczy wiadomości w Gwar Connect",
  "account.archiveUploadsHint": "Zaszyfrowane klucze Twoich rozmów są przechowywane w Gwar Connect, dzięki czemu Twoje inne urządzenia i kod odzyskiwania mogą otworzyć ich historię. Connect nie może ich odczytać. Wyłączone: to urządzenie nic nie wysyła, ale nadal czyta kopię.",
  "account.devicesFailed": "Nie udało się wczytać urządzeń.",
  "account.refresh": "Odśwież",
  "account.revoked": "Unieważnione",
  "account.lastSeen": "Ostatnio widziane {when}",
  "account.revoke": "Unieważnij",
  "account.revokeTitle": "Unieważnij: {name}",
  "account.revokeBody": "Podaj hasło, aby unieważnić to urządzenie. Nie będzie już mogło występować jako Ty na serwerach; zauważą to w ciągu kilku minut.",
  "account.deviceRevoked": "Urządzenie unieważnione.",
  "account.thisRevoked": "To urządzenie zostało unieważnione. Wyloguj się i zaloguj ponownie, aby używać konta.",
  "account.certificate": "Logowanie na tym urządzeniu",
  "account.certExpires": "Na tym urządzeniu jesteś zalogowany do {date}.",
  "account.renew": "Zaloguj ponownie",
  "account.renewTitle": "Zaloguj ponownie na tym urządzeniu",
  "account.renewBody": "Wpisz hasło do Gwar Connect, aby nadal korzystać z konta na tym urządzeniu.",
  "account.renewed": "Zalogowano ponownie na tym urządzeniu.",
  "account.renewWithPassword": "Zaloguj ponownie",
  "account.certExpiringWarn": "Wpisz ponownie hasło do {date}, aby nadal łączyć się z serwerami na tym urządzeniu.",
  "account.certExpiredWarn": "Wpisz ponownie hasło, aby łączyć się na tym urządzeniu. Twoja nazwa i role są bezpieczne.",
  "account.changePassword": "Zmień hasło",
  "account.passwordChanged": "Hasło zmienione. Pozostałe sesje zostały wylogowane.",
  "account.signOut": "Wyloguj się",
  "account.signOutHint": "Wrócisz do tożsamości zapisanej na tym urządzeniu (identyfikator {uid}). Konto zostaje w Gwar Connect.",
  "account.confirm": "Potwierdź",
  "account.err.network": "Nie można połączyć się z Gwar Connect. Sprawdź połączenie i spróbuj ponownie.",
  "account.err.password": "Błędna nazwa konta lub hasło.",
  "account.err.passwordOnly": "Błędne hasło.",
  "account.err.code": "Błędna nazwa konta lub kod odzyskiwania.",
  "account.err.rate": "Za dużo prób. Spróbuj ponownie za kilka minut.",
  "account.err.taken": "Ta nazwa konta jest zajęta albo ta tożsamość ma już konto.",
  "account.err.revoked": "To urządzenie zostało unieważnione.",
  "account.err.session": "Sesja wygasła. Odnów certyfikat (podając hasło), aby ją odświeżyć.",
  "account.err.other": "Gwar Connect zgłosił błąd: {message}",
  "identity.connectNote":
    "Jesteś zalogowany przez Gwar Connect jako @{handle}. Tożsamość należy do konta i jest taka sama na każdym urządzeniu. Zarządzasz nią w zakładce Konto.",
  "identity.accountKey": "Klucz konta",
  "ts.title": "Tożsamości TeamSpeak",
  "ts.introAccount":
    "Dopóki jesteś zalogowany, serwery TeamSpeak znają cię po tożsamościach TeamSpeak twojego konta, tych samych we wszystkich aplikacjach desktopowych. Są przechowywane zaszyfrowane w Gwar Connect.",
  "ts.introDevice":
    "Serwery TeamSpeak znają cię po jednej z tych tożsamości. Zaloguj się do Gwar Connect, aby używać tych samych we wszystkich aplikacjach desktopowych.",
  "ts.empty": "Nie ma jeszcze tożsamości. Pierwsza powstanie przy pierwszym połączeniu z serwerem TeamSpeak.",
  "ts.listLabel": "Tożsamości TeamSpeak",
  "ts.default": "Domyślna",
  "ts.level": "Poziom bezpieczeństwa {level}",
  "ts.copyUid": "Kopiuj unikalny identyfikator",
  "ts.rename": "Zmień nazwę",
  "ts.setDefault": "Ustaw jako domyślną",
  "ts.export": "Eksportuj do klienta TeamSpeak",
  "ts.delete": "Usuń",
  "ts.add": "Dodaj",
  "ts.import": "Importuj z klienta TeamSpeak…",
  "ts.generate": "Wygeneruj nową…",
  "ts.find": "Znajdź na tym komputerze…",
  "ts.name": "Nazwa",
  "ts.unnamed": "Tożsamość {n}",
  "ts.added": "Dodano tożsamość TeamSpeak.",
  "ts.alreadyListed": "Ta tożsamość jest już na liście.",
  "ts.changeFailed": "Nie udało się zmienić tożsamości: {message}",
  "ts.importTitle": "Importuj tożsamość TeamSpeak",
  "ts.importBody":
    "Wklej ciąg tożsamości albo zawartość pliku .ini z tożsamością wyeksportowanego z klienta TeamSpeak (TeamSpeak 3: Narzędzia, Tożsamości, Eksportuj; TeamSpeak 6: prawy przycisk na tożsamości, Eksportuj).",
  "ts.importField": "Tożsamość",
  "ts.importFile": "Wybierz plik…",
  "ts.importFailed": "Nie udało się dodać tożsamości: {message}",
  "ts.generateTitle": "Wygeneruj nową tożsamość",
  "ts.generateBody": "Na tym urządzeniu powstanie nowa tożsamość TeamSpeak. Serwery TeamSpeak widzą ją jako nową osobę, dopóki nie nadadzą jej grup.",
  "ts.generateAction": "Wygeneruj",
  "ts.findTitle": "Tożsamości TeamSpeak na tym komputerze",
  "ts.findBody": "Te tożsamości zapisał oficjalny klient TeamSpeak na tym komputerze. Wybierz te, których chcesz tu używać.",
  "ts.findSearching": "Szukam…",
  "ts.findError": "Nie udało się wyszukać: {message}",
  "ts.findNone":
    "Nie znaleziono tożsamości TeamSpeak. W kliencie TeamSpeak wyeksportuj tożsamość do pliku .ini (TeamSpeak 3: Narzędzia, Tożsamości, Eksportuj; TeamSpeak 6: prawy przycisk na tożsamości, Eksportuj), a potem użyj tutaj „Importuj z klienta TeamSpeak”. Pliki .ini obu wersji działają.",
  "ts.findImport": "Importuj zaznaczone",
  "ts.findLastUsed": "ostatnio używana",
  "ts.findLow": "Poziom bezpieczeństwa {level}, a serwery wymagają co najmniej {min}. Najpierw podnieś go w kliencie TeamSpeak.",
  "ts.findHave": "Już dodana",
  "ts.findAdded": "Zaimportowane tożsamości: {count}",
  "ts.firstTitle": "Użyć twojej tożsamości TeamSpeak?",
  "ts.firstBody":
    "Klient TeamSpeak na tym komputerze ma tożsamości. Użyj jednej z nich, a serwery TeamSpeak cię rozpoznają i zachowasz swoje grupy. Możesz też utworzyć nową.",
  "ts.firstUse": "Użyj zaznaczonych",
  "ts.firstNew": "Utwórz nową",
  "ts.renameTitle": "Zmień nazwę tożsamości",
  "ts.deleteTitle": "Usunąć „{name}”?",
  "ts.deleteBodyAccount":
    "Tożsamość zniknie z twojego konta, na wszystkich urządzeniach. Grupy i uprawnienia na serwerach, które od niej zależą, przepadną, chyba że wcześniej ją wyeksportujesz.",
  "ts.deleteBodyDevice":
    "Tożsamość zniknie z tego urządzenia. Grupy i uprawnienia na serwerach, które od niej zależą, przepadną, chyba że wcześniej ją wyeksportujesz.",
  "ts.deleteAction": "Usuń tożsamość",
  "ts.deleted": "Tożsamość usunięta.",
  "ts.exportTitle": "Eksport „{name}” do klienta TeamSpeak",
  "ts.exportBody": "W kliencie TeamSpeak zaimportuj ten ciąg (Narzędzia, Tożsamości, Importuj), aby używać tam tej samej tożsamości.",
  "ts.exportWarning": "To tajny klucz. Kto go ma, może podszyć się pod ciebie na serwerach TeamSpeak. Nie udostępniaj go.",
  "ts.webLabel": "Tych tożsamości TeamSpeak używają twoje aplikacje desktopowe.",
  "ts.webNone": "Nie ma jeszcze tożsamości TeamSpeak. Pierwsza aplikacja desktopowa, w której się zalogujesz, zapisze tu swoje.",
  "ts.loadFailed": "Nie udało się wczytać tożsamości TeamSpeak: {message}",
  "ts.pickerDefault": "{name} (domyślna)",
  "tsClaim.title": "Role z TeamSpeaka",
  "tsClaim.body":
    "Ten serwer przeniósł się z TeamSpeaka, a te twoje tożsamości TeamSpeak mają tu role. Przenieść je na twoje konto Gwar? Wejście z tymi tożsamościami na TeamSpeaku będzie wtedy liczone jako ty, a inni na tym serwerze zobaczą, że są twoje.",
  "tsClaim.accept": "Przejmij role",
  "tsClaim.later": "Nie teraz",
  "tsClaim.done": "Twoje role z TeamSpeaka są teraz na twoim koncie na tym serwerze.",
  "tsClaim.failed": "Nie udało się przejąć części tożsamości TeamSpeak.",
  "tsClaim.linked": "Tożsamości TeamSpeak",
  "tsClaim.unlink": "Odłącz",
  "tsClaim.unlinkConfirm": "Odłączyć tę tożsamość TeamSpeak? Role zostają; wejście z nią na TeamSpeaku nie będzie już liczone jako ten członek.",
  "tsClaim.unlinked": "Tożsamość TeamSpeak odłączona.",
  "tsClaim.check": "Przejmij role z TeamSpeaka",
  "tsClaim.codes": "Twoje konto tutaj: {account}… · ten serwer: {server}…. Pytanie Gwara o każdą tożsamość pokazuje te same kody.",
  "tsClaim.none": "Żadna z twoich tożsamości TeamSpeak nie ma tu ról.",

  "close.removed": "{by} usunął(a) Cię z serwera. Możesz dołączyć ponownie jako nowy członek.",
  "mod.remove": "Usuń członka…",
  "mod.removeNamed": "Usuń {name}",
  "mod.removeTitle": "Usunąć {name}?",
  "mod.removeBody": "Wpis tej osoby zostanie skasowany razem z rolami i znacznikami przeczytania. To nie jest ban: osoba może dołączyć ponownie jako nowy członek.",
  "mod.removeMessages": "Usuń też wiadomości i pliki tej osoby",
  "mod.removeMessagesHint": "Bez tego wiadomości zostają, nadal z nazwą autora.",
  "mod.removeNote": "Żeby wrócić, osoba potrzebuje hasła serwera lub zaproszenia, jak każdy nowy.",
  "mod.removeNoteOnline": "Osoba jest online i zostanie rozłączona od razu. Żeby wrócić, potrzebuje hasła serwera lub zaproszenia, jak każdy nowy.",
  "mod.removed": "Usunięto: {name}.",
  "ss.cleanup": "Porządki",
  "ss.cleanupIntro": "Usuń osoby, których dawno tu nie było. To nie jest ban: mogą dołączyć ponownie jako nowi członkowie.",
  "ss.pruneDays": "Nieobecni od (dni)",
  "ss.pruneDaysHint": "Od 1 do {max} dni.",
  "ss.pruneDaysInvalid": "Podaj całkowitą liczbę dni od 1 do {max}.",
  "ss.pruneKeepRoles": "Zostaw członków z rolami",
  "ss.pruneKeepRolesHint": "Administratorzy, moderatorzy i każdy z rolą inną niż Członek zostają.",
  "ss.pruneMessages": "Usuń też ich wiadomości i pliki",
  "ss.pruneMessagesHint": "Bez tego wiadomości zostają, nadal z ich nazwami.",
  "ss.pruneAlwaysKept": "Osoby online, Ty oraz każdy z uprawnieniami, których nie masz, zawsze zostają.",
  "ss.prunePreview": "Podgląd",
  "ss.pruneRemoveIdle": "Usuń",
  "ss.pruneRunning": "Usuwanie… {done} z {total}",
  "ss.pruneListLabel": "Osoby do usunięcia",
  "ss.pruneNone": "Nikt nie pasuje. Nie ma co usuwać.",
  "ss.pruneMore": "…i jeszcze {count}",
  "ss.pruneFound.one": "Zostanie usunięta {count} osoba",
  "ss.pruneFound.other": "Zostanie usuniętych {count} osób",
  "ss.pruneFound.few": "Zostaną usunięte {count} osoby",
  "ss.pruneFound.many": "Zostanie usuniętych {count} osób",
  "ss.pruneRemove.one": "Usuń {count} osobę",
  "ss.pruneRemove.other": "Usuń {count} osób",
  "ss.pruneRemove.few": "Usuń {count} osoby",
  "ss.pruneRemove.many": "Usuń {count} osób",
  "ss.pruneDone.one": "Usunięto {count} osobę.",
  "ss.pruneDone.other": "Usunięto {count} osób.",
  "ss.pruneDone.few": "Usunięto {count} osoby.",
  "ss.pruneDone.many": "Usunięto {count} osób.",
  "common.advanced": "Zaawansowane",
  "common.details": "Szczegóły",
  "onboarding.title": "Jak mają Cię widzieć inni?",
  "onboarding.hint": "Wybierz nazwę, po której znajomi Cię rozpoznają. Możesz ją później zmienić.",
  "onboarding.name": "Twoja nazwa",
  "onboarding.continue": "Dalej",
  "onboarding.skip": "Na razie pomiń",
  "connect.publicServer": "Dołącz do publicznego serwera (gwar.app)",
  "identity.keepIdentity": "Zabezpiecz swoją tożsamość — bez kopii stracisz nazwę i role po wyczyszczeniu danych przeglądarki.",
  "identity.keepIdentityDesktop": "Zabezpiecz swoją tożsamość — bez kopii stracisz nazwę i role po usunięciu danych Gwar.",
  "identity.protectTitle": "Zabezpiecz swoją tożsamość",
  "identity.protect": "Zabezpiecz",
  "identity.lossWarning": "Jeśli wyczyścisz dane przeglądarki, stracisz swoją nazwę i role.",
  "identity.lossWarningDesktop": "Jeśli usuniesz dane Gwar z tego komputera, stracisz swoją nazwę i role.",
  "identity.createConnectAccount": "Załóż konto Gwar Connect",
  "identity.createAccount": "Załóż konto",
  "identity.exportBackup": "Zapisz kopię",
  "identity.exportFailed": "Nie udało się wyeksportować kopii. Spróbuj ponownie.",
  "account.signInAgain": "Zaloguj ponownie",
  "account.signInShort": "Zaloguj",
  "account.signInExpiredShort": "Logowanie wygasło",
  "account.signInDaysShort.one": "Zaloguj się w ciągu {count} dnia",
  "account.signInDaysShort.few": "Zaloguj się w ciągu {count} dni",
  "account.signInDaysShort.many": "Zaloguj się w ciągu {count} dni",
  "account.signInDaysShort.other": "Zaloguj się w ciągu {count} dni",
  "account.signInExpired": "Wpisz ponownie hasło na tym urządzeniu, aby łączyć się z serwerami. Twoja nazwa i role są bezpieczne.",
  "account.signInDays.one": "Za {count} dzień trzeba będzie ponownie wpisać hasło na tym urządzeniu.",
  "account.signInDays.few": "Za {count} dni trzeba będzie ponownie wpisać hasło na tym urządzeniu.",
  "account.signInDays.many": "Za {count} dni trzeba będzie ponownie wpisać hasło na tym urządzeniu.",
  "account.signInDays.other": "Za {count} dni trzeba będzie ponownie wpisać hasło na tym urządzeniu.",
  "server.connected": "Połączono",
  "screen.qualityGood": "Dobra jakość",
  "err.channel.save": "Nie udało się zapisać kanału. Sprawdź jego ustawienia i spróbuj ponownie.",
  "common.loading": "Wczytywanie…",
  "screen.shareAgain": "Udostępnij ponownie",
  "voice.channelRemoved": "Kanał głosowy został usunięty. Dołącz do innego kanału, aby rozmawiać.",
  "voice.disconnected": "Głos został rozłączony.",
  "voice.reconnectFailed": "Nie udało się ponownie połączyć głosu.",
  "identity.backupSecret": "Plik zawiera Twój klucz prywatny. Nie udostępniaj go nikomu — kto go ma, może podszyć się pod Ciebie.",
  "audio.pttModeHint": "Mów, przytrzymując wybrany klawisz.",
  "audio.noiseSuggestion": "Włącz redukcję szumów, jeśli słychać tło.",
  "audio.manualUnsupported": "Ten serwer nie obsługuje ręcznej czułości.",
  "audio.pttUnsupported": "Tryb „naciśnij i mów” wymaga nowszego serwera.",
  "err.voice.input_mode_unsupported": "Ten serwer nie obsługuje trybu „naciśnij i mów”. Wybierz aktywację głosem.",
};
